
var Rive = (() => {
  var _scriptName = typeof document != 'undefined' ? document.currentScript?.src : undefined;
  
  return (
function(moduleArg = {}) {
  var moduleRtn;

var k = moduleArg, aa, ba, ca = new Promise((a, b) => {
  aa = a;
  ba = b;
}), da = "object" == typeof window, ea = "function" == typeof importScripts;
function fa() {
  function a(g) {
    const h = d;
    c = b = 0;
    d = new Map();
    h.forEach(m => {
      try {
        m(g);
      } catch (l) {
        console.error(l);
      }
    });
    this.fb();
    e && e.Eb();
  }
  let b = 0, c = 0, d = new Map(), e = null, f = null;
  this.requestAnimationFrame = function(g) {
    b ||= requestAnimationFrame(a.bind(this));
    const h = ++c;
    d.set(h, g);
    return h;
  };
  this.cancelAnimationFrame = function(g) {
    d.delete(g);
    b && 0 == d.size && (cancelAnimationFrame(b), b = 0);
  };
  this.Cb = function(g) {
    f && (document.body.remove(f), f = null);
    g || (f = document.createElement("div"), f.style.backgroundColor = "black", f.style.position = "fixed", f.style.right = 0, f.style.top = 0, f.style.color = "white", f.style.padding = "4px", f.innerHTML = "RIVE FPS", g = function(h) {
      f.innerHTML = "RIVE FPS " + h.toFixed(1);
    }, document.body.appendChild(f));
    e = new function() {
      let h = 0, m = 0;
      this.Eb = function() {
        var l = performance.now();
        m ? (++h, l -= m, 1000 < l && (g(1000 * h / l), h = m = 0)) : (m = l, h = 0);
      };
    }();
  };
  this.fb = function() {
  };
}
function ha() {
  console.assert(!0);
  const a = new Map();
  let b = -Infinity;
  this.push = function(c) {
    c = c + 255 >> 8;
    a.has(c) && clearTimeout(a.get(c));
    a.set(c, setTimeout(function() {
      a.delete(c);
      0 == a.length ? b = -Infinity : c == b && (b = Math.max(...a.keys()), console.assert(b < c));
    }, 1000));
    b = Math.max(c, b);
    return b << 8;
  };
}
const ia = k.onRuntimeInitialized;
k.onRuntimeInitialized = function() {
  ia && ia();
  let a = k.decodeAudio;
  k.decodeAudio = function(f, g) {
    f = a(f);
    g(f);
  };
  let b = k.decodeFont;
  k.decodeFont = function(f, g) {
    f = b(f);
    g(f);
  };
  let c = k.setFallbackFontCb;
  k.setFallbackFontCallback = "function" === typeof c ? function(f) {
    c(f);
  } : function() {
    console.warn("Module.setFallbackFontCallback called, but text support is not enabled in this build.");
  };
  const d = k.FileAssetLoader;
  k.ptrToAsset = f => {
    let g = k.ptrToFileAsset(f);
    return g.isImage ? k.ptrToImageAsset(f) : g.isFont ? k.ptrToFontAsset(f) : g.isAudio ? k.ptrToAudioAsset(f) : g;
  };
  k.CustomFileAssetLoader = d.extend("CustomFileAssetLoader", {__construct:function({loadContents:f}) {
    this.__parent.__construct.call(this);
    this.sb = f;
  }, loadContents:function(f, g) {
    f = k.ptrToAsset(f);
    return this.sb(f, g);
  },});
  k.CDNFileAssetLoader = d.extend("CDNFileAssetLoader", {__construct:function() {
    this.__parent.__construct.call(this);
  }, loadContents:function(f) {
    let g = k.ptrToAsset(f);
    f = g.cdnUuid;
    if ("" === f) {
      return !1;
    }
    (function(h, m) {
      var l = new XMLHttpRequest();
      l.responseType = "arraybuffer";
      l.onreadystatechange = function() {
        4 == l.readyState && 200 == l.status && m(l);
      };
      l.open("GET", h, !0);
      l.send(null);
    })(g.cdnBaseUrl + "/" + f, h => {
      g.decode(new Uint8Array(h.response));
    });
    return !0;
  },});
  k.FallbackFileAssetLoader = d.extend("FallbackFileAssetLoader", {__construct:function() {
    this.__parent.__construct.call(this);
    this.ab = [];
  }, addLoader:function(f) {
    this.ab.push(f);
  }, loadContents:function(f, g) {
    for (let h of this.ab) {
      if (h.loadContents(f, g)) {
        return !0;
      }
    }
    return !1;
  },});
  let e = k.computeAlignment;
  k.computeAlignment = function(f, g, h, m, l = 1.0) {
    return e.call(this, f, g, h, m, l);
  };
};
const ja = k.onRuntimeInitialized;
k.onRuntimeInitialized = function() {
  function a(q) {
    this.D = q;
    this.rb = q.getContext("2d");
    this.Sa = d;
    this.O = [];
    this.ga = 0;
    this.clear = function() {
      console.assert(0 == this.ga);
      this.O = [];
      e.delete(this);
    };
    this.save = function() {
      ++this.ga;
      this.O.push(d.save.bind(d));
    };
    this.restore = function() {
      0 < this.ga && (this.O.push(d.restore.bind(d)), --this.ga);
    };
    this.transform = function(t) {
      this.O.push(d.transform.bind(d, t));
    };
    this.align = function(t, y, z, B, G = 1.0) {
      this.O.push(d.align.bind(d, t, y, z, B, G));
    };
    this.flush = function() {
      console.assert(0 == this.ga);
      e.add(this);
      d.Ra || c();
    };
    this.bindContext = function() {
      const t = this.Sa;
      t && t.W && ka(t.W);
    };
    this["delete"] = function() {
    };
  }
  function b(q, t = !1) {
    var y = {alpha:!0, depth:t, stencil:t, antialias:t, premultipliedAlpha:!0, preserveDrawingBuffer:0, powerPreference:"high-performance", failIfMajorPerformanceCaveat:0, enableExtensionsByDefault:!1, explicitSwapControl:0, renderViaOffscreenBackBuffer:0,};
    t = q.getContext("webgl2", y);
    if (!t) {
      return null;
    }
    y = la(t, y);
    ka(y);
    const z = f(q.width, q.height);
    z.W = y;
    z.D = q;
    z.Ia = q.width;
    z.Ha = q.height;
    z.P = t;
    z.wb = function() {
      this.W && ka(this.W);
    };
    var B = z.delete;
    z.delete = function() {
      this.wb();
      B.call(this);
      var G = this.W;
      p === v[G] && (p = null);
      "object" == typeof JSEvents && JSEvents.Gc(v[G].C.canvas);
      v[G] && v[G].C.canvas && (v[G].C.canvas.qb = void 0);
      this.W = this.D = this.Ia = this.Ha = this.P = v[G] = null;
    };
    return z;
  }
  function c() {
    if (d) {
      var q = d.ub, t = 0, y = 0, z = 0, B = Array(e.size), G = 0;
      for (var I of e) {
        I.ca = Math.min(I.D.width, q), I.ba = Math.min(I.D.height, q), I.Fa = I.ba * I.ca, t = Math.max(t, I.ca), y = Math.max(y, I.ba), z += I.Fa, B[G++] = I;
      }
      e.clear();
      if (!(0 >= z)) {
        t = 1 << (0 >= t ? 0 : 32 - Math.clz32(t - 1));
        for (y = 1 << (0 >= y ? 0 : 32 - Math.clz32(y - 1)); y * t < z;) {
          t <= y ? t *= 2 : y *= 2;
        }
        t = Math.min(t, q);
        t = Math.min(y, q);
        B.sort((Y, nb) => nb.Fa - Y.Fa);
        z = new k.DynamicRectanizer(q);
        for (I = 0; I < B.length;) {
          z.reset(t, y);
          for (G = I; G < B.length; ++G) {
            var J = B[G], H = z.addRect(J.ca, J.ba);
            if (0 > H) {
              console.assert(G > I);
              break;
            }
            J.ma = H & 65535;
            J.na = H >> 16;
          }
          J = m.push(z.drawWidth());
          H = l.push(z.drawHeight());
          console.assert(J >= z.drawWidth());
          console.assert(H >= z.drawHeight());
          console.assert(J <= q);
          console.assert(H <= q);
          d.D.width != J && (d.D.width = J);
          d.D.height != H && (d.D.height = H);
          d.clear();
          for (J = I; J < G; ++J) {
            H = B[J];
            d.saveClipRect(H.ma, H.na, H.ma + H.ca, H.na + H.ba);
            let Y = new k.Mat2D();
            Y.xx = H.ca / H.D.width;
            Y.yy = H.ba / H.D.height;
            Y.xy = Y.yx = 0;
            Y.tx = H.ma;
            Y.ty = H.na;
            d.transform(Y);
            for (const nb of H.O) {
              nb();
            }
            d.restoreClipRect();
            H.O = [];
          }
          for (d.flush(); I < G; ++I) {
            J = B[I], H = J.rb, H.globalCompositeOperation = "copy", H.drawImage(d.D, J.ma, J.na, J.ca, J.ba, 0, 0, J.D.width, J.D.height);
          }
          I = G;
        }
      }
    }
  }
  ja && ja();
  let d = null;
  const e = new Set(), f = k.makeRenderer;
  k.makeRenderer = function(q, t) {
    if (!d) {
      function y(z) {
        var B = document.createElement("canvas");
        B.width = 1;
        B.height = 1;
        d = b(B, z);
        if (!d) {
          return null;
        }
        d.Ra = !!d.P.getExtension("WEBGL_shader_pixel_local_storage");
        d.ub = Math.min(d.P.getParameter(d.P.MAX_RENDERBUFFER_SIZE), d.P.getParameter(d.P.MAX_TEXTURE_SIZE));
        d.Ga = !d.Ra;
        if (z = d.P.getExtension("WEBGL_debug_renderer_info")) {
          B = d.P.getParameter(z.UNMASKED_RENDERER_WEBGL), d.P.getParameter(z.UNMASKED_VENDOR_WEBGL).includes("Google") && B.includes("ANGLE Metal Renderer") && (d.Ga = !1);
        }
        return d;
      }
      d = y(!0);
      if (!d) {
        throw "Unable to create WebGL context, your environment may not support WebGL. Try out @rive-app/canvas as an alternative.";
      }
      d.Ga || (d = y(!1));
    }
    return t ? new a(q) : b(q, d.Ga);
  };
  const g = k.Artboard.prototype["delete"];
  k.Artboard.prototype["delete"] = function() {
    this.vb = !0;
    g.call(this);
  };
  const h = k.Artboard.prototype.draw;
  k.Artboard.prototype.draw = function(q) {
    q.O ? q.O.push(() => {
      this.vb || h.call(this, q.Sa);
    }) : h.call(this, q);
  };
  const m = new ha(), l = new ha(), r = new fa();
  k.requestAnimationFrame = r.requestAnimationFrame.bind(r);
  k.cancelAnimationFrame = r.cancelAnimationFrame.bind(r);
  k.enableFPSCounter = r.Cb.bind(r);
  r.fb = c;
  k.resolveAnimationFrame = c;
  let u = k.load;
  k.load = function(q, t, y = !0) {
    const z = new k.FallbackFileAssetLoader();
    void 0 !== t && z.addLoader(t);
    y && (t = new k.CDNFileAssetLoader(), z.addLoader(t));
    return Promise.resolve(u(q, z));
  };
  const w = k.WebGL2Renderer.prototype.clear;
  k.WebGL2Renderer.prototype.clear = function() {
    ka(this.W);
    const q = this.D;
    if (this.Ia != q.width || this.Ha != q.height) {
      this.resize(q.width, q.height), this.Ia = q.width, this.Ha = q.height;
    }
    w.call(this);
  };
  k.decodeImage = function(q, t) {
    q = k.decodeWebGL2Image(q);
    t(q);
  };
  let n = k.Renderer.prototype.align;
  k.Renderer.prototype.align = function(q, t, y, z, B = 1.0) {
    n.call(this, q, t, y, z, B);
  };
};
var ma = Object.assign({}, k), na = "./this.program", x = "", oa, pa;
if (da || ea) {
  ea ? x = self.location.href : "undefined" != typeof document && document.currentScript && (x = document.currentScript.src), _scriptName && (x = _scriptName), x.startsWith("blob:") ? x = "" : x = x.substr(0, x.replace(/[?#].*/, "").lastIndexOf("/") + 1), ea && (pa = a => {
    var b = new XMLHttpRequest();
    b.open("GET", a, !1);
    b.responseType = "arraybuffer";
    b.send(null);
    return new Uint8Array(b.response);
  }), oa = (a, b, c) => {
    if (qa(a)) {
      var d = new XMLHttpRequest();
      d.open("GET", a, !0);
      d.responseType = "arraybuffer";
      d.onload = () => {
        200 == d.status || 0 == d.status && d.response ? b(d.response) : c();
      };
      d.onerror = c;
      d.send(null);
    } else {
      fetch(a, {credentials:"same-origin"}).then(e => e.ok ? e.arrayBuffer() : Promise.reject(Error(e.status + " : " + e.url))).then(b, c);
    }
  };
}
var ra = k.print || console.log.bind(console), A = k.printErr || console.error.bind(console);
Object.assign(k, ma);
ma = null;
k.thisProgram && (na = k.thisProgram);
var sa;
k.wasmBinary && (sa = k.wasmBinary);
var ta, ua = !1, C, D, E, va, F, K, wa, xa;
function ya() {
  var a = ta.buffer;
  k.HEAP8 = C = new Int8Array(a);
  k.HEAP16 = E = new Int16Array(a);
  k.HEAPU8 = D = new Uint8Array(a);
  k.HEAPU16 = va = new Uint16Array(a);
  k.HEAP32 = F = new Int32Array(a);
  k.HEAPU32 = K = new Uint32Array(a);
  k.HEAPF32 = wa = new Float32Array(a);
  k.HEAPF64 = xa = new Float64Array(a);
}
var za = [], Aa = [], Ba = [];
function Ca() {
  var a = k.preRun.shift();
  za.unshift(a);
}
var Da = 0, Ea = null, Fa = null;
function Ga(a) {
  k.onAbort?.(a);
  a = "Aborted(" + a + ")";
  A(a);
  ua = !0;
  a = new WebAssembly.RuntimeError(a + ". Build with -sASSERTIONS for more info.");
  ba(a);
  throw a;
}
var Ha = a => a.startsWith("data:application/octet-stream;base64,"), qa = a => a.startsWith("file://"), Ia;
function Ja(a) {
  if (a == Ia && sa) {
    return new Uint8Array(sa);
  }
  if (pa) {
    return pa(a);
  }
  throw "both async and sync fetching of the wasm failed";
}
function Ka(a) {
  return sa ? Promise.resolve().then(() => Ja(a)) : new Promise((b, c) => {
    oa(a, d => b(new Uint8Array(d)), () => {
      try {
        b(Ja(a));
      } catch (d) {
        c(d);
      }
    });
  });
}
function La(a, b, c) {
  return Ka(a).then(d => WebAssembly.instantiate(d, b)).then(c, d => {
    A(`failed to asynchronously prepare wasm: ${d}`);
    Ga(d);
  });
}
function Ma(a, b) {
  var c = Ia;
  return sa || "function" != typeof WebAssembly.instantiateStreaming || Ha(c) || qa(c) || "function" != typeof fetch ? La(c, a, b) : fetch(c, {credentials:"same-origin"}).then(d => WebAssembly.instantiateStreaming(d, a).then(b, function(e) {
    A(`wasm streaming compile failed: ${e}`);
    A("falling back to ArrayBuffer instantiation");
    return La(c, a, b);
  }));
}
var Na, Oa, Sa = {573535:(a, b, c, d, e) => {
  if ("undefined" === typeof window || void 0 === (window.AudioContext || window.webkitAudioContext)) {
    return 0;
  }
  if ("undefined" === typeof window.miniaudio) {
    window.miniaudio = {referenceCount:0};
    window.miniaudio.device_type = {};
    window.miniaudio.device_type.playback = a;
    window.miniaudio.device_type.capture = b;
    window.miniaudio.device_type.duplex = c;
    window.miniaudio.device_state = {};
    window.miniaudio.device_state.stopped = d;
    window.miniaudio.device_state.started = e;
    let f = window.miniaudio;
    f.devices = [];
    f.track_device = function(g) {
      for (var h = 0; h < f.devices.length; ++h) {
        if (null == f.devices[h]) {
          return f.devices[h] = g, h;
        }
      }
      f.devices.push(g);
      return f.devices.length - 1;
    };
    f.untrack_device_by_index = function(g) {
      for (f.devices[g] = null; 0 < f.devices.length;) {
        if (null == f.devices[f.devices.length - 1]) {
          f.devices.pop();
        } else {
          break;
        }
      }
    };
    f.untrack_device = function(g) {
      for (var h = 0; h < f.devices.length; ++h) {
        if (f.devices[h] == g) {
          return f.untrack_device_by_index(h);
        }
      }
    };
    f.get_device_by_index = function(g) {
      return f.devices[g];
    };
    f.unlock_event_types = ["touchend", "click"];
    f.unlock = function() {
      for (var g = 0; g < f.devices.length; ++g) {
        var h = f.devices[g];
        null != h && null != h.H && h.state === f.device_state.started && h.H.resume().then(() => {
          Pa(h.gb);
        }, m => {
          console.error("Failed to resume audiocontext", m);
        });
      }
      f.unlock_event_types.map(function(m) {
        document.removeEventListener(m, f.unlock, !0);
      });
    };
    f.unlock_event_types.map(function(g) {
      document.addEventListener(g, f.unlock, !0);
    });
  }
  window.miniaudio.referenceCount += 1;
  return 1;
}, 575713:() => {
  "undefined" !== typeof window.miniaudio && (window.miniaudio.unlock_event_types.map(function(a) {
    document.removeEventListener(a, window.miniaudio.unlock, !0);
  }), --window.miniaudio.referenceCount, 0 === window.miniaudio.referenceCount && delete window.miniaudio);
}, 576017:() => void 0 !== navigator.mediaDevices && void 0 !== navigator.mediaDevices.getUserMedia, 576121:() => {
  try {
    var a = new (window.AudioContext || window.webkitAudioContext)(), b = a.sampleRate;
    a.close();
    return b;
  } catch (c) {
    return 0;
  }
}, 576292:(a, b, c, d, e, f) => {
  if ("undefined" === typeof window.miniaudio) {
    return -1;
  }
  var g = {}, h = {};
  a == window.miniaudio.device_type.playback && 0 != c && (h.sampleRate = c);
  g.H = new (window.AudioContext || window.webkitAudioContext)(h);
  g.H.suspend();
  g.state = window.miniaudio.device_state.stopped;
  c = 0;
  a != window.miniaudio.device_type.playback && (c = b);
  g.V = g.H.createScriptProcessor(d, c, b);
  g.V.onaudioprocess = function(m) {
    if (null == g.ra || 0 == g.ra.length) {
      g.ra = new Float32Array(wa.buffer, e, d * b);
    }
    if (a == window.miniaudio.device_type.capture || a == window.miniaudio.device_type.duplex) {
      for (var l = 0; l < b; l += 1) {
        for (var r = m.inputBuffer.getChannelData(l), u = g.ra, w = 0; w < d; w += 1) {
          u[w * b + l] = r[w];
        }
      }
      Qa(f, d, e);
    }
    if (a == window.miniaudio.device_type.playback || a == window.miniaudio.device_type.duplex) {
      for (Ra(f, d, e), l = 0; l < m.outputBuffer.numberOfChannels; ++l) {
        for (r = m.outputBuffer.getChannelData(l), u = g.ra, w = 0; w < d; w += 1) {
          r[w] = u[w * b + l];
        }
      }
    } else {
      for (l = 0; l < m.outputBuffer.numberOfChannels; ++l) {
        m.outputBuffer.getChannelData(l).fill(0.0);
      }
    }
  };
  a != window.miniaudio.device_type.capture && a != window.miniaudio.device_type.duplex || navigator.mediaDevices.getUserMedia({audio:!0, video:!1}).then(function(m) {
    g.Ba = g.H.createMediaStreamSource(m);
    g.Ba.connect(g.V);
    g.V.connect(g.H.destination);
  }).catch(function(m) {
    console.log("Failed to get user media: " + m);
  });
  a == window.miniaudio.device_type.playback && g.V.connect(g.H.destination);
  g.gb = f;
  return window.miniaudio.track_device(g);
}, 579169:a => window.miniaudio.get_device_by_index(a).H.sampleRate, 579242:a => {
  a = window.miniaudio.get_device_by_index(a);
  void 0 !== a.V && (a.V.onaudioprocess = function() {
  }, a.V.disconnect(), a.V = void 0);
  void 0 !== a.Ba && (a.Ba.disconnect(), a.Ba = void 0);
  a.H.close();
  a.H = void 0;
  a.gb = void 0;
}, 579642:a => {
  window.miniaudio.untrack_device_by_index(a);
}, 579692:a => {
  a = window.miniaudio.get_device_by_index(a);
  a.H.resume();
  a.state = window.miniaudio.device_state.started;
}, 579831:a => {
  a = window.miniaudio.get_device_by_index(a);
  a.H.suspend();
  a.state = window.miniaudio.device_state.stopped;
}}, Ta = a => {
  for (; 0 < a.length;) {
    a.shift()(k);
  }
};
function Ua() {
  var a = F[+Va >> 2];
  Va += 4;
  return a;
}
var Wa = (a, b) => {
  for (var c = 0, d = a.length - 1; 0 <= d; d--) {
    var e = a[d];
    "." === e ? a.splice(d, 1) : ".." === e ? (a.splice(d, 1), c++) : c && (a.splice(d, 1), c--);
  }
  if (b) {
    for (; c; c--) {
      a.unshift("..");
    }
  }
  return a;
}, Xa = a => {
  var b = "/" === a.charAt(0), c = "/" === a.substr(-1);
  (a = Wa(a.split("/").filter(d => !!d), !b).join("/")) || b || (a = ".");
  a && c && (a += "/");
  return (b ? "/" : "") + a;
}, Ya = a => {
  var b = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(a).slice(1);
  a = b[0];
  b = b[1];
  if (!a && !b) {
    return ".";
  }
  b &&= b.substr(0, b.length - 1);
  return a + b;
}, Za = a => {
  if ("/" === a) {
    return "/";
  }
  a = Xa(a);
  a = a.replace(/\/$/, "");
  var b = a.lastIndexOf("/");
  return -1 === b ? a : a.substr(b + 1);
}, $a = () => {
  if ("object" == typeof crypto && "function" == typeof crypto.getRandomValues) {
    return a => crypto.getRandomValues(a);
  }
  Ga("initRandomDevice");
}, ab = a => (ab = $a())(a), bb = (...a) => {
  for (var b = "", c = !1, d = a.length - 1; -1 <= d && !c; d--) {
    c = 0 <= d ? a[d] : "/";
    if ("string" != typeof c) {
      throw new TypeError("Arguments to path.resolve must be strings");
    }
    if (!c) {
      return "";
    }
    b = c + "/" + b;
    c = "/" === c.charAt(0);
  }
  b = Wa(b.split("/").filter(e => !!e), !c).join("/");
  return (c ? "/" : "") + b || ".";
}, cb = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, L = (a, b, c) => {
  var d = b + c;
  for (c = b; a[c] && !(c >= d);) {
    ++c;
  }
  if (16 < c - b && a.buffer && cb) {
    return cb.decode(a.subarray(b, c));
  }
  for (d = ""; b < c;) {
    var e = a[b++];
    if (e & 128) {
      var f = a[b++] & 63;
      if (192 == (e & 224)) {
        d += String.fromCharCode((e & 31) << 6 | f);
      } else {
        var g = a[b++] & 63;
        e = 224 == (e & 240) ? (e & 15) << 12 | f << 6 | g : (e & 7) << 18 | f << 12 | g << 6 | a[b++] & 63;
        65536 > e ? d += String.fromCharCode(e) : (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023));
      }
    } else {
      d += String.fromCharCode(e);
    }
  }
  return d;
}, db = [], eb = a => {
  for (var b = 0, c = 0; c < a.length; ++c) {
    var d = a.charCodeAt(c);
    127 >= d ? b++ : 2047 >= d ? b += 2 : 55296 <= d && 57343 >= d ? (b += 4, ++c) : b += 3;
  }
  return b;
}, fb = (a, b, c, d) => {
  if (!(0 < d)) {
    return 0;
  }
  var e = c;
  d = c + d - 1;
  for (var f = 0; f < a.length; ++f) {
    var g = a.charCodeAt(f);
    if (55296 <= g && 57343 >= g) {
      var h = a.charCodeAt(++f);
      g = 65536 + ((g & 1023) << 10) | h & 1023;
    }
    if (127 >= g) {
      if (c >= d) {
        break;
      }
      b[c++] = g;
    } else {
      if (2047 >= g) {
        if (c + 1 >= d) {
          break;
        }
        b[c++] = 192 | g >> 6;
      } else {
        if (65535 >= g) {
          if (c + 2 >= d) {
            break;
          }
          b[c++] = 224 | g >> 12;
        } else {
          if (c + 3 >= d) {
            break;
          }
          b[c++] = 240 | g >> 18;
          b[c++] = 128 | g >> 12 & 63;
        }
        b[c++] = 128 | g >> 6 & 63;
      }
      b[c++] = 128 | g & 63;
    }
  }
  b[c] = 0;
  return c - e;
};
function gb(a, b) {
  var c = Array(eb(a) + 1);
  a = fb(a, c, 0, c.length);
  b && (c.length = a);
  return c;
}
var hb = [];
function ib(a, b) {
  hb[a] = {input:[], F:[], S:b};
  jb(a, kb);
}
var kb = {open(a) {
  var b = hb[a.node.Aa];
  if (!b) {
    throw new M(43);
  }
  a.o = b;
  a.seekable = !1;
}, close(a) {
  a.o.S.pa(a.o);
}, pa(a) {
  a.o.S.pa(a.o);
}, read(a, b, c, d) {
  if (!a.o || !a.o.S.$a) {
    throw new M(60);
  }
  for (var e = 0, f = 0; f < d; f++) {
    try {
      var g = a.o.S.$a(a.o);
    } catch (h) {
      throw new M(29);
    }
    if (void 0 === g && 0 === e) {
      throw new M(6);
    }
    if (null === g || void 0 === g) {
      break;
    }
    e++;
    b[c + f] = g;
  }
  e && (a.node.timestamp = Date.now());
  return e;
}, write(a, b, c, d) {
  if (!a.o || !a.o.S.Ma) {
    throw new M(60);
  }
  try {
    for (var e = 0; e < d; e++) {
      a.o.S.Ma(a.o, b[c + e]);
    }
  } catch (f) {
    throw new M(29);
  }
  d && (a.node.timestamp = Date.now());
  return e;
},}, lb = {$a() {
  a: {
    if (!db.length) {
      var a = null;
      "undefined" != typeof window && "function" == typeof window.prompt && (a = window.prompt("Input: "), null !== a && (a += "\n"));
      if (!a) {
        a = null;
        break a;
      }
      db = gb(a, !0);
    }
    a = db.shift();
  }
  return a;
}, Ma(a, b) {
  null === b || 10 === b ? (ra(L(a.F, 0)), a.F = []) : 0 != b && a.F.push(b);
}, pa(a) {
  a.F && 0 < a.F.length && (ra(L(a.F, 0)), a.F = []);
}, Nb() {
  return {nc:25856, pc:5, mc:191, oc:35387, lc:[3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,]};
}, Ob() {
  return 0;
}, Pb() {
  return [24, 80];
},}, mb = {Ma(a, b) {
  null === b || 10 === b ? (A(L(a.F, 0)), a.F = []) : 0 != b && a.F.push(b);
}, pa(a) {
  a.F && 0 < a.F.length && (A(L(a.F, 0)), a.F = []);
},};
function ob(a, b) {
  var c = a.j ? a.j.length : 0;
  c >= b || (b = Math.max(b, c * (1048576 > c ? 2.0 : 1.125) >>> 0), 0 != c && (b = Math.max(b, 256)), c = a.j, a.j = new Uint8Array(b), 0 < a.u && a.j.set(c.subarray(0, a.u), 0));
}
var N = {K:null, R() {
  return N.createNode(null, "/", 16895, 0);
}, createNode(a, b, c, d) {
  if (24576 === (c & 61440) || 4096 === (c & 61440)) {
    throw new M(63);
  }
  N.K || (N.K = {dir:{node:{U:N.i.U, M:N.i.M, ha:N.i.ha, xa:N.i.xa, lb:N.i.lb, pb:N.i.pb, mb:N.i.mb, kb:N.i.kb, Ca:N.i.Ca}, stream:{Z:N.l.Z}}, file:{node:{U:N.i.U, M:N.i.M}, stream:{Z:N.l.Z, read:N.l.read, write:N.l.write, Ta:N.l.Ta, bb:N.l.bb, eb:N.l.eb}}, link:{node:{U:N.i.U, M:N.i.M, ia:N.i.ia}, stream:{}}, Ua:{node:{U:N.i.U, M:N.i.M}, stream:pb}});
  c = qb(a, b, c, d);
  16384 === (c.mode & 61440) ? (c.i = N.K.dir.node, c.l = N.K.dir.stream, c.j = {}) : 32768 === (c.mode & 61440) ? (c.i = N.K.file.node, c.l = N.K.file.stream, c.u = 0, c.j = null) : 40960 === (c.mode & 61440) ? (c.i = N.K.link.node, c.l = N.K.link.stream) : 8192 === (c.mode & 61440) && (c.i = N.K.Ua.node, c.l = N.K.Ua.stream);
  c.timestamp = Date.now();
  a && (a.j[b] = c, a.timestamp = c.timestamp);
  return c;
}, vc(a) {
  return a.j ? a.j.subarray ? a.j.subarray(0, a.u) : new Uint8Array(a.j) : new Uint8Array(0);
}, i:{U(a) {
  var b = {};
  b.sc = 8192 === (a.mode & 61440) ? a.id : 1;
  b.xc = a.id;
  b.mode = a.mode;
  b.Dc = 1;
  b.uid = 0;
  b.wc = 0;
  b.Aa = a.Aa;
  16384 === (a.mode & 61440) ? b.size = 4096 : 32768 === (a.mode & 61440) ? b.size = a.u : 40960 === (a.mode & 61440) ? b.size = a.link.length : b.size = 0;
  b.jc = new Date(a.timestamp);
  b.Cc = new Date(a.timestamp);
  b.qc = new Date(a.timestamp);
  b.xb = 4096;
  b.kc = Math.ceil(b.size / b.xb);
  return b;
}, M(a, b) {
  void 0 !== b.mode && (a.mode = b.mode);
  void 0 !== b.timestamp && (a.timestamp = b.timestamp);
  if (void 0 !== b.size && (b = b.size, a.u != b)) {
    if (0 == b) {
      a.j = null, a.u = 0;
    } else {
      var c = a.j;
      a.j = new Uint8Array(b);
      c && a.j.set(c.subarray(0, Math.min(b, a.u)));
      a.u = b;
    }
  }
}, ha() {
  throw rb[44];
}, xa(a, b, c, d) {
  return N.createNode(a, b, c, d);
}, lb(a, b, c) {
  if (16384 === (a.mode & 61440)) {
    try {
      var d = sb(b, c);
    } catch (f) {
    }
    if (d) {
      for (var e in d.j) {
        throw new M(55);
      }
    }
  }
  delete a.parent.j[a.name];
  a.parent.timestamp = Date.now();
  a.name = c;
  b.j[c] = a;
  b.timestamp = a.parent.timestamp;
}, pb(a, b) {
  delete a.j[b];
  a.timestamp = Date.now();
}, mb(a, b) {
  var c = sb(a, b), d;
  for (d in c.j) {
    throw new M(55);
  }
  delete a.j[b];
  a.timestamp = Date.now();
}, kb(a) {
  var b = [".", ".."], c;
  for (c of Object.keys(a.j)) {
    b.push(c);
  }
  return b;
}, Ca(a, b, c) {
  a = N.createNode(a, b, 41471, 0);
  a.link = c;
  return a;
}, ia(a) {
  if (40960 !== (a.mode & 61440)) {
    throw new M(28);
  }
  return a.link;
},}, l:{read(a, b, c, d, e) {
  var f = a.node.j;
  if (e >= a.node.u) {
    return 0;
  }
  a = Math.min(a.node.u - e, d);
  if (8 < a && f.subarray) {
    b.set(f.subarray(e, e + a), c);
  } else {
    for (d = 0; d < a; d++) {
      b[c + d] = f[e + d];
    }
  }
  return a;
}, write(a, b, c, d, e, f) {
  b.buffer === C.buffer && (f = !1);
  if (!d) {
    return 0;
  }
  a = a.node;
  a.timestamp = Date.now();
  if (b.subarray && (!a.j || a.j.subarray)) {
    if (f) {
      return a.j = b.subarray(c, c + d), a.u = d;
    }
    if (0 === a.u && 0 === e) {
      return a.j = b.slice(c, c + d), a.u = d;
    }
    if (e + d <= a.u) {
      return a.j.set(b.subarray(c, c + d), e), d;
    }
  }
  ob(a, e + d);
  if (a.j.subarray && b.subarray) {
    a.j.set(b.subarray(c, c + d), e);
  } else {
    for (f = 0; f < d; f++) {
      a.j[e + f] = b[c + f];
    }
  }
  a.u = Math.max(a.u, e + d);
  return d;
}, Z(a, b, c) {
  1 === c ? b += a.position : 2 === c && 32768 === (a.node.mode & 61440) && (b += a.node.u);
  if (0 > b) {
    throw new M(28);
  }
  return b;
}, Ta(a, b, c) {
  ob(a.node, b + c);
  a.node.u = Math.max(a.node.u, b + c);
}, bb(a, b, c, d, e) {
  if (32768 !== (a.node.mode & 61440)) {
    throw new M(43);
  }
  a = a.node.j;
  if (e & 2 || a.buffer !== C.buffer) {
    if (0 < c || c + b < a.length) {
      a.subarray ? a = a.subarray(c, c + b) : a = Array.prototype.slice.call(a, c, c + b);
    }
    c = !0;
    Ga();
    b = void 0;
    if (!b) {
      throw new M(48);
    }
    C.set(a, b);
  } else {
    c = !1, b = a.byteOffset;
  }
  return {m:b, ic:c};
}, eb(a, b, c, d) {
  N.l.write(a, b, 0, d, c, !1);
  return 0;
},},}, tb = (a, b) => {
  var c = 0;
  a && (c |= 365);
  b && (c |= 146);
  return c;
}, ub = null, vb = {}, wb = [], xb = 1, yb = null, zb = !0, M = class {
  constructor(a) {
    this.name = "ErrnoError";
    this.Y = a;
  }
}, rb = {}, Ab = class {
  constructor() {
    this.qa = {};
    this.node = null;
  }
  get flags() {
    return this.qa.flags;
  }
  set flags(a) {
    this.qa.flags = a;
  }
  get position() {
    return this.qa.position;
  }
  set position(a) {
    this.qa.position = a;
  }
}, Bb = class {
  constructor(a, b, c, d) {
    a ||= this;
    this.parent = a;
    this.R = a.R;
    this.ya = null;
    this.id = xb++;
    this.name = b;
    this.mode = c;
    this.i = {};
    this.l = {};
    this.Aa = d;
  }
  get read() {
    return 365 === (this.mode & 365);
  }
  set read(a) {
    a ? this.mode |= 365 : this.mode &= -366;
  }
  get write() {
    return 146 === (this.mode & 146);
  }
  set write(a) {
    a ? this.mode |= 146 : this.mode &= -147;
  }
};
function Cb(a, b = {}) {
  a = bb(a);
  if (!a) {
    return {path:"", node:null};
  }
  b = Object.assign({Za:!0, Oa:0}, b);
  if (8 < b.Oa) {
    throw new M(32);
  }
  a = a.split("/").filter(g => !!g);
  for (var c = ub, d = "/", e = 0; e < a.length; e++) {
    var f = e === a.length - 1;
    if (f && b.parent) {
      break;
    }
    c = sb(c, a[e]);
    d = Xa(d + "/" + a[e]);
    c.ya && (!f || f && b.Za) && (c = c.ya.root);
    if (!f || b.Ya) {
      for (f = 0; 40960 === (c.mode & 61440);) {
        if (c = Db(d), d = bb(Ya(d), c), c = Cb(d, {Oa:b.Oa + 1}).node, 40 < f++) {
          throw new M(32);
        }
      }
    }
  }
  return {path:d, node:c};
}
function Eb(a) {
  for (var b;;) {
    if (a === a.parent) {
      return a = a.R.cb, b ? "/" !== a[a.length - 1] ? `${a}/${b}` : a + b : a;
    }
    b = b ? `${a.name}/${b}` : a.name;
    a = a.parent;
  }
}
function Fb(a, b) {
  for (var c = 0, d = 0; d < b.length; d++) {
    c = (c << 5) - c + b.charCodeAt(d) | 0;
  }
  return (a + c >>> 0) % yb.length;
}
function sb(a, b) {
  var c = 16384 === (a.mode & 61440) ? (c = Gb(a, "x")) ? c : a.i.ha ? 0 : 2 : 54;
  if (c) {
    throw new M(c);
  }
  for (c = yb[Fb(a.id, b)]; c; c = c.Sb) {
    var d = c.name;
    if (c.parent.id === a.id && d === b) {
      return c;
    }
  }
  return a.i.ha(a, b);
}
function qb(a, b, c, d) {
  a = new Bb(a, b, c, d);
  b = Fb(a.parent.id, a.name);
  a.Sb = yb[b];
  return yb[b] = a;
}
function Hb(a) {
  var b = ["r", "w", "rw"][a & 3];
  a & 512 && (b += "w");
  return b;
}
function Gb(a, b) {
  if (zb) {
    return 0;
  }
  if (!b.includes("r") || a.mode & 292) {
    if (b.includes("w") && !(a.mode & 146) || b.includes("x") && !(a.mode & 73)) {
      return 2;
    }
  } else {
    return 2;
  }
  return 0;
}
function Ib(a, b) {
  try {
    return sb(a, b), 20;
  } catch (c) {
  }
  return Gb(a, "wx");
}
function Jb(a) {
  a = wb[a];
  if (!a) {
    throw new M(8);
  }
  return a;
}
function Kb(a, b = -1) {
  a = Object.assign(new Ab(), a);
  if (-1 == b) {
    a: {
      for (b = 0; 4096 >= b; b++) {
        if (!wb[b]) {
          break a;
        }
      }
      throw new M(33);
    }
  }
  a.T = b;
  return wb[b] = a;
}
function Lb(a, b = -1) {
  a = Kb(a, b);
  a.l?.uc?.(a);
  return a;
}
var pb = {open(a) {
  a.l = vb[a.node.Aa].l;
  a.l.open?.(a);
}, Z() {
  throw new M(70);
},};
function jb(a, b) {
  vb[a] = {l:b};
}
function Mb(a, b) {
  var c = "/" === b;
  if (c && ub) {
    throw new M(10);
  }
  if (!c && b) {
    var d = Cb(b, {Za:!1});
    b = d.path;
    d = d.node;
    if (d.ya) {
      throw new M(10);
    }
    if (16384 !== (d.mode & 61440)) {
      throw new M(54);
    }
  }
  b = {type:a, Fc:{}, cb:b, Qb:[]};
  a = a.R(b);
  a.R = b;
  b.root = a;
  c ? ub = a : d && (d.ya = b, d.R && d.R.Qb.push(b));
}
function Nb(a, b, c) {
  var d = Cb(a, {parent:!0}).node;
  a = Za(a);
  if (!a || "." === a || ".." === a) {
    throw new M(28);
  }
  var e = Ib(d, a);
  if (e) {
    throw new M(e);
  }
  if (!d.i.xa) {
    throw new M(63);
  }
  return d.i.xa(d, a, b, c);
}
function Ob(a) {
  return Nb(a, 16895, 0);
}
function Pb(a, b, c) {
  "undefined" == typeof c && (c = b, b = 438);
  Nb(a, b | 8192, c);
}
function Qb(a, b) {
  if (!bb(a)) {
    throw new M(44);
  }
  var c = Cb(b, {parent:!0}).node;
  if (!c) {
    throw new M(44);
  }
  b = Za(b);
  var d = Ib(c, b);
  if (d) {
    throw new M(d);
  }
  if (!c.i.Ca) {
    throw new M(63);
  }
  c.i.Ca(c, b, a);
}
function Db(a) {
  a = Cb(a).node;
  if (!a) {
    throw new M(44);
  }
  if (!a.i.ia) {
    throw new M(28);
  }
  return bb(Eb(a.parent), a.i.ia(a));
}
function Rb(a, b, c) {
  if ("" === a) {
    throw new M(44);
  }
  if ("string" == typeof b) {
    var d = {r:0, "r+":2, w:577, "w+":578, a:1089, "a+":1090,}[b];
    if ("undefined" == typeof d) {
      throw Error(`Unknown file open mode: ${b}`);
    }
    b = d;
  }
  c = b & 64 ? ("undefined" == typeof c ? 438 : c) & 4095 | 32768 : 0;
  if ("object" == typeof a) {
    var e = a;
  } else {
    a = Xa(a);
    try {
      e = Cb(a, {Ya:!(b & 131072)}).node;
    } catch (f) {
    }
  }
  d = !1;
  if (b & 64) {
    if (e) {
      if (b & 128) {
        throw new M(20);
      }
    } else {
      e = Nb(a, c, 0), d = !0;
    }
  }
  if (!e) {
    throw new M(44);
  }
  8192 === (e.mode & 61440) && (b &= -513);
  if (b & 65536 && 16384 !== (e.mode & 61440)) {
    throw new M(54);
  }
  if (!d && (c = e ? 40960 === (e.mode & 61440) ? 32 : 16384 === (e.mode & 61440) && ("r" !== Hb(b) || b & 512) ? 31 : Gb(e, Hb(b)) : 44)) {
    throw new M(c);
  }
  if (b & 512 && !d) {
    c = e;
    c = "string" == typeof c ? Cb(c, {Ya:!0}).node : c;
    if (!c.i.M) {
      throw new M(63);
    }
    if (16384 === (c.mode & 61440)) {
      throw new M(31);
    }
    if (32768 !== (c.mode & 61440)) {
      throw new M(28);
    }
    if (d = Gb(c, "w")) {
      throw new M(d);
    }
    c.i.M(c, {size:0, timestamp:Date.now()});
  }
  b &= -131713;
  e = Kb({node:e, path:Eb(e), flags:b, seekable:!0, position:0, l:e.l, cc:[], error:!1});
  e.l.open && e.l.open(e);
  !k.logReadFiles || b & 1 || (Sb ||= {}, a in Sb || (Sb[a] = 1));
  return e;
}
function Tb(a, b, c) {
  if (null === a.T) {
    throw new M(8);
  }
  if (!a.seekable || !a.l.Z) {
    throw new M(70);
  }
  if (0 != c && 1 != c && 2 != c) {
    throw new M(28);
  }
  a.position = a.l.Z(a, b, c);
  a.cc = [];
}
var Ub;
function Vb(a, b, c) {
  a = Xa("/dev/" + a);
  var d = tb(!!b, !!c);
  Wb ||= 64;
  var e = Wb++ << 8 | 0;
  jb(e, {open(f) {
    f.seekable = !1;
  }, close() {
    c?.buffer?.length && c(10);
  }, read(f, g, h, m) {
    for (var l = 0, r = 0; r < m; r++) {
      try {
        var u = b();
      } catch (w) {
        throw new M(29);
      }
      if (void 0 === u && 0 === l) {
        throw new M(6);
      }
      if (null === u || void 0 === u) {
        break;
      }
      l++;
      g[h + r] = u;
    }
    l && (f.node.timestamp = Date.now());
    return l;
  }, write(f, g, h, m) {
    for (var l = 0; l < m; l++) {
      try {
        c(g[h + l]);
      } catch (r) {
        throw new M(29);
      }
    }
    m && (f.node.timestamp = Date.now());
    return l;
  }});
  Pb(a, d, e);
}
var Wb, Xb = {}, Sb, Va = void 0, Yb = (a, b) => Object.defineProperty(b, "name", {value:a}), Zb = [], O = [], P, Q = a => {
  if (!a) {
    throw new P("Cannot use deleted val. handle = " + a);
  }
  return O[a];
}, $b = a => {
  switch(a) {
    case void 0:
      return 2;
    case null:
      return 4;
    case !0:
      return 6;
    case !1:
      return 8;
    default:
      const b = Zb.pop() || O.length;
      O[b] = a;
      O[b + 1] = 1;
      return b;
  }
}, ac = a => {
  var b = Error, c = Yb(a, function(d) {
    this.name = a;
    this.message = d;
    d = Error(d).stack;
    void 0 !== d && (this.stack = this.toString() + "\n" + d.replace(/^Error(:[^\n]*)?\n/, ""));
  });
  c.prototype = Object.create(b.prototype);
  c.prototype.constructor = c;
  c.prototype.toString = function() {
    return void 0 === this.message ? this.name : `${this.name}: ${this.message}`;
  };
  return c;
}, bc, cc, R = a => {
  for (var b = ""; D[a];) {
    b += cc[D[a++]];
  }
  return b;
}, dc = [], ec = () => {
  for (; dc.length;) {
    var a = dc.pop();
    a.g.ea = !1;
    a["delete"]();
  }
}, fc, gc = {}, hc = (a, b) => {
  if (void 0 === b) {
    throw new P("ptr should not be undefined");
  }
  for (; a.A;) {
    b = a.ka(b), a = a.A;
  }
  return b;
}, ic = {}, lc = a => {
  a = jc(a);
  var b = R(a);
  kc(a);
  return b;
}, mc = (a, b) => {
  var c = ic[a];
  if (void 0 === c) {
    throw a = `${b} has unknown type ${lc(a)}`, new P(a);
  }
  return c;
}, nc = () => {
}, oc = !1, pc = (a, b, c) => {
  if (b === c) {
    return a;
  }
  if (void 0 === c.A) {
    return null;
  }
  a = pc(a, b, c.A);
  return null === a ? null : c.Ab(a);
}, qc = {}, rc = (a, b) => {
  b = hc(a, b);
  return gc[b];
}, sc, uc = (a, b) => {
  if (!b.s || !b.m) {
    throw new sc("makeClassHandle requires ptr and ptrType");
  }
  if (!!b.G !== !!b.B) {
    throw new sc("Both smartPtrType and smartPtr must be specified");
  }
  b.count = {value:1};
  return tc(Object.create(a, {g:{value:b, writable:!0,},}));
}, tc = a => {
  if ("undefined" === typeof FinalizationRegistry) {
    return tc = b => b, a;
  }
  oc = new FinalizationRegistry(b => {
    b = b.g;
    --b.count.value;
    0 === b.count.value && (b.B ? b.G.L(b.B) : b.s.h.L(b.m));
  });
  tc = b => {
    var c = b.g;
    c.B && oc.register(b, {g:c}, b);
    return b;
  };
  nc = b => {
    oc.unregister(b);
  };
  return tc(a);
}, vc = {}, wc = a => {
  for (; a.length;) {
    var b = a.pop();
    a.pop()(b);
  }
};
function xc(a) {
  return this.fromWireType(K[a >> 2]);
}
var yc = {}, zc = {}, T = (a, b, c) => {
  function d(h) {
    h = c(h);
    if (h.length !== a.length) {
      throw new sc("Mismatched type converter count");
    }
    for (var m = 0; m < a.length; ++m) {
      S(a[m], h[m]);
    }
  }
  a.forEach(function(h) {
    zc[h] = b;
  });
  var e = Array(b.length), f = [], g = 0;
  b.forEach((h, m) => {
    ic.hasOwnProperty(h) ? e[m] = ic[h] : (f.push(h), yc.hasOwnProperty(h) || (yc[h] = []), yc[h].push(() => {
      e[m] = ic[h];
      ++g;
      g === f.length && d(e);
    }));
  });
  0 === f.length && d(e);
};
function Ac(a, b, c = {}) {
  var d = b.name;
  if (!a) {
    throw new P(`type "${d}" must have a positive integer typeid pointer`);
  }
  if (ic.hasOwnProperty(a)) {
    if (c.Kb) {
      return;
    }
    throw new P(`Cannot register type '${d}' twice`);
  }
  ic[a] = b;
  delete zc[a];
  yc.hasOwnProperty(a) && (b = yc[a], delete yc[a], b.forEach(e => e()));
}
function S(a, b, c = {}) {
  if (!("argPackAdvance" in b)) {
    throw new TypeError("registerType registeredInstance requires argPackAdvance");
  }
  return Ac(a, b, c);
}
var Bc = a => {
  throw new P(a.g.s.h.name + " instance already deleted");
};
function Cc() {
}
var Dc = (a, b, c) => {
  if (void 0 === a[b].v) {
    var d = a[b];
    a[b] = function(...e) {
      if (!a[b].v.hasOwnProperty(e.length)) {
        throw new P(`Function '${c}' called with an invalid number of arguments (${e.length}) - expects one of (${a[b].v})!`);
      }
      return a[b].v[e.length].apply(this, e);
    };
    a[b].v = [];
    a[b].v[d.da] = d;
  }
}, Ec = (a, b, c) => {
  if (k.hasOwnProperty(a)) {
    if (void 0 === c || void 0 !== k[a].v && void 0 !== k[a].v[c]) {
      throw new P(`Cannot register public name '${a}' twice`);
    }
    Dc(k, a, a);
    if (k.hasOwnProperty(c)) {
      throw new P(`Cannot register multiple overloads of a function with the same number of arguments (${c})!`);
    }
    k[a].v[c] = b;
  } else {
    k[a] = b, void 0 !== c && (k[a].Ec = c);
  }
}, Fc = a => {
  if (void 0 === a) {
    return "_unknown";
  }
  a = a.replace(/[^a-zA-Z0-9_]/g, "$");
  var b = a.charCodeAt(0);
  return 48 <= b && 57 >= b ? `_${a}` : a;
};
function Gc(a, b, c, d, e, f, g, h) {
  this.name = a;
  this.constructor = b;
  this.J = c;
  this.L = d;
  this.A = e;
  this.Fb = f;
  this.ka = g;
  this.Ab = h;
  this.hb = [];
}
var Hc = (a, b, c) => {
  for (; b !== c;) {
    if (!b.ka) {
      throw new P(`Expected null or instance of ${c.name}, got an instance of ${b.name}`);
    }
    a = b.ka(a);
    b = b.A;
  }
  return a;
};
function Ic(a, b) {
  if (null === b) {
    if (this.La) {
      throw new P(`null is not a valid ${this.name}`);
    }
    return 0;
  }
  if (!b.g) {
    throw new P(`Cannot pass "${Jc(b)}" as a ${this.name}`);
  }
  if (!b.g.m) {
    throw new P(`Cannot pass deleted object as a pointer of type ${this.name}`);
  }
  return Hc(b.g.m, b.g.s.h, this.h);
}
function Kc(a, b) {
  if (null === b) {
    if (this.La) {
      throw new P(`null is not a valid ${this.name}`);
    }
    if (this.ta) {
      var c = this.Na();
      null !== a && a.push(this.L, c);
      return c;
    }
    return 0;
  }
  if (!b || !b.g) {
    throw new P(`Cannot pass "${Jc(b)}" as a ${this.name}`);
  }
  if (!b.g.m) {
    throw new P(`Cannot pass deleted object as a pointer of type ${this.name}`);
  }
  if (!this.sa && b.g.s.sa) {
    throw new P(`Cannot convert argument of type ${b.g.G ? b.g.G.name : b.g.s.name} to parameter type ${this.name}`);
  }
  c = Hc(b.g.m, b.g.s.h, this.h);
  if (this.ta) {
    if (void 0 === b.g.B) {
      throw new P("Passing raw pointer to smart pointer is illegal");
    }
    switch(this.Yb) {
      case 0:
        if (b.g.G === this) {
          c = b.g.B;
        } else {
          throw new P(`Cannot convert argument of type ${b.g.G ? b.g.G.name : b.g.s.name} to parameter type ${this.name}`);
        }
        break;
      case 1:
        c = b.g.B;
        break;
      case 2:
        if (b.g.G === this) {
          c = b.g.B;
        } else {
          var d = b.clone();
          c = this.Ub(c, $b(() => d["delete"]()));
          null !== a && a.push(this.L, c);
        }
        break;
      default:
        throw new P("Unsupporting sharing policy");
    }
  }
  return c;
}
function Lc(a, b) {
  if (null === b) {
    if (this.La) {
      throw new P(`null is not a valid ${this.name}`);
    }
    return 0;
  }
  if (!b.g) {
    throw new P(`Cannot pass "${Jc(b)}" as a ${this.name}`);
  }
  if (!b.g.m) {
    throw new P(`Cannot pass deleted object as a pointer of type ${this.name}`);
  }
  if (b.g.s.sa) {
    throw new P(`Cannot convert argument of type ${b.g.s.name} to parameter type ${this.name}`);
  }
  return Hc(b.g.m, b.g.s.h, this.h);
}
function Mc(a, b, c, d, e, f, g, h, m, l, r) {
  this.name = a;
  this.h = b;
  this.La = c;
  this.sa = d;
  this.ta = e;
  this.Tb = f;
  this.Yb = g;
  this.jb = h;
  this.Na = m;
  this.Ub = l;
  this.L = r;
  e || void 0 !== b.A ? this.toWireType = Kc : (this.toWireType = d ? Ic : Lc, this.I = null);
}
var Nc = (a, b, c) => {
  if (!k.hasOwnProperty(a)) {
    throw new sc("Replacing nonexistent public symbol");
  }
  void 0 !== k[a].v && void 0 !== c ? k[a].v[c] = b : (k[a] = b, k[a].da = c);
}, Oc = [], Pc, Qc = a => {
  var b = Oc[a];
  b || (a >= Oc.length && (Oc.length = a + 1), Oc[a] = b = Pc.get(a));
  return b;
}, Rc = (a, b, c = []) => {
  a.includes("j") ? (a = a.replace(/p/g, "i"), b = (0,k["dynCall_" + a])(b, ...c)) : b = Qc(b)(...c);
  return b;
}, Sc = (a, b) => (...c) => Rc(a, b, c), U = (a, b) => {
  a = R(a);
  var c = a.includes("j") ? Sc(a, b) : Qc(b);
  if ("function" != typeof c) {
    throw new P(`unknown function pointer with signature ${a}: ${b}`);
  }
  return c;
}, Tc, Uc = (a, b) => {
  function c(f) {
    e[f] || ic[f] || (zc[f] ? zc[f].forEach(c) : (d.push(f), e[f] = !0));
  }
  var d = [], e = {};
  b.forEach(c);
  throw new Tc(`${a}: ` + d.map(lc).join([", "]));
};
function Vc(a) {
  for (var b = 1; b < a.length; ++b) {
    if (null !== a[b] && void 0 === a[b].I) {
      return !0;
    }
  }
  return !1;
}
function Wc(a, b, c, d, e) {
  var f = b.length;
  if (2 > f) {
    throw new P("argTypes array size mismatch! Must at least get return value and 'this' types!");
  }
  var g = null !== b[1] && null !== c, h = Vc(b), m = "void" !== b[0].name, l = f - 2, r = Array(l), u = [], w = [];
  return Yb(a, function(...n) {
    if (n.length !== l) {
      throw new P(`function ${a} called with ${n.length} arguments, expected ${l}`);
    }
    w.length = 0;
    u.length = g ? 2 : 1;
    u[0] = e;
    if (g) {
      var q = b[1].toWireType(w, this);
      u[1] = q;
    }
    for (var t = 0; t < l; ++t) {
      r[t] = b[t + 2].toWireType(w, n[t]), u.push(r[t]);
    }
    n = d(...u);
    if (h) {
      wc(w);
    } else {
      for (t = g ? 1 : 2; t < b.length; t++) {
        var y = 1 === t ? q : r[t - 2];
        null !== b[t].I && b[t].I(y);
      }
    }
    q = m ? b[0].fromWireType(n) : void 0;
    return q;
  });
}
var Xc = (a, b) => {
  for (var c = [], d = 0; d < a; d++) {
    c.push(K[b + 4 * d >> 2]);
  }
  return c;
}, Yc = a => {
  a = a.trim();
  const b = a.indexOf("(");
  return -1 !== b ? a.substr(0, b) : a;
}, Zc = (a, b, c) => {
  if (!(a instanceof Object)) {
    throw new P(`${c} with invalid "this": ${a}`);
  }
  if (!(a instanceof b.h.constructor)) {
    throw new P(`${c} incompatible with "this" of type ${a.constructor.name}`);
  }
  if (!a.g.m) {
    throw new P(`cannot call emscripten binding method ${c} on deleted object`);
  }
  return Hc(a.g.m, a.g.s.h, b.h);
}, $c = a => {
  9 < a && 0 === --O[a + 1] && (O[a] = void 0, Zb.push(a));
}, ad = {name:"emscripten::val", fromWireType:a => {
  var b = Q(a);
  $c(a);
  return b;
}, toWireType:(a, b) => $b(b), argPackAdvance:8, readValueFromPointer:xc, I:null,}, bd = (a, b, c) => {
  switch(b) {
    case 1:
      return c ? function(d) {
        return this.fromWireType(C[d]);
      } : function(d) {
        return this.fromWireType(D[d]);
      };
    case 2:
      return c ? function(d) {
        return this.fromWireType(E[d >> 1]);
      } : function(d) {
        return this.fromWireType(va[d >> 1]);
      };
    case 4:
      return c ? function(d) {
        return this.fromWireType(F[d >> 2]);
      } : function(d) {
        return this.fromWireType(K[d >> 2]);
      };
    default:
      throw new TypeError(`invalid integer width (${b}): ${a}`);
  }
}, Jc = a => {
  if (null === a) {
    return "null";
  }
  var b = typeof a;
  return "object" === b || "array" === b || "function" === b ? a.toString() : "" + a;
}, cd = (a, b) => {
  switch(b) {
    case 4:
      return function(c) {
        return this.fromWireType(wa[c >> 2]);
      };
    case 8:
      return function(c) {
        return this.fromWireType(xa[c >> 3]);
      };
    default:
      throw new TypeError(`invalid float width (${b}): ${a}`);
  }
}, dd = (a, b, c) => {
  switch(b) {
    case 1:
      return c ? d => C[d] : d => D[d];
    case 2:
      return c ? d => E[d >> 1] : d => va[d >> 1];
    case 4:
      return c ? d => F[d >> 2] : d => K[d >> 2];
    default:
      throw new TypeError(`invalid integer width (${b}): ${a}`);
  }
}, ed = "undefined" != typeof TextDecoder ? new TextDecoder("utf-16le") : void 0, fd = (a, b) => {
  var c = a >> 1;
  for (var d = c + b / 2; !(c >= d) && va[c];) {
    ++c;
  }
  c <<= 1;
  if (32 < c - a && ed) {
    return ed.decode(D.subarray(a, c));
  }
  c = "";
  for (d = 0; !(d >= b / 2); ++d) {
    var e = E[a + 2 * d >> 1];
    if (0 == e) {
      break;
    }
    c += String.fromCharCode(e);
  }
  return c;
}, gd = (a, b, c) => {
  c ??= 2147483647;
  if (2 > c) {
    return 0;
  }
  c -= 2;
  var d = b;
  c = c < 2 * a.length ? c / 2 : a.length;
  for (var e = 0; e < c; ++e) {
    E[b >> 1] = a.charCodeAt(e), b += 2;
  }
  E[b >> 1] = 0;
  return b - d;
}, hd = a => 2 * a.length, jd = (a, b) => {
  for (var c = 0, d = ""; !(c >= b / 4);) {
    var e = F[a + 4 * c >> 2];
    if (0 == e) {
      break;
    }
    ++c;
    65536 <= e ? (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023)) : d += String.fromCharCode(e);
  }
  return d;
}, kd = (a, b, c) => {
  c ??= 2147483647;
  if (4 > c) {
    return 0;
  }
  var d = b;
  c = d + c - 4;
  for (var e = 0; e < a.length; ++e) {
    var f = a.charCodeAt(e);
    if (55296 <= f && 57343 >= f) {
      var g = a.charCodeAt(++e);
      f = 65536 + ((f & 1023) << 10) | g & 1023;
    }
    F[b >> 2] = f;
    b += 4;
    if (b + 4 > c) {
      break;
    }
  }
  F[b >> 2] = 0;
  return b - d;
}, ld = a => {
  for (var b = 0, c = 0; c < a.length; ++c) {
    var d = a.charCodeAt(c);
    55296 <= d && 57343 >= d && ++c;
    b += 4;
  }
  return b;
}, md = (a, b, c) => {
  var d = [];
  a = a.toWireType(d, c);
  d.length && (K[b >> 2] = $b(d));
  return a;
}, nd = [], od = {}, pd = a => {
  var b = od[a];
  return void 0 === b ? R(a) : b;
}, qd = a => {
  var b = nd.length;
  nd.push(a);
  return b;
}, rd = (a, b) => {
  for (var c = Array(a), d = 0; d < a; ++d) {
    c[d] = mc(K[b + 4 * d >> 2], "parameter " + d);
  }
  return c;
}, sd = Reflect.construct, td = a => 0 === a % 4 && (0 !== a % 100 || 0 === a % 400), ud = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335], vd = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], wd = [], xd = a => {
  a.tc = a.getExtension("WEBGL_draw_instanced_base_vertex_base_instance");
}, yd = a => {
  a.Bc = a.getExtension("WEBGL_multi_draw_instanced_base_vertex_base_instance");
}, zd = a => {
  var b = "EXT_color_buffer_float EXT_conservative_depth EXT_disjoint_timer_query_webgl2 EXT_texture_norm16 NV_shader_noperspective_interpolation WEBGL_clip_cull_distance EXT_color_buffer_half_float EXT_depth_clamp EXT_float_blend EXT_texture_compression_bptc EXT_texture_compression_rgtc EXT_texture_filter_anisotropic KHR_parallel_shader_compile OES_texture_float_linear WEBGL_blend_func_extended WEBGL_compressed_texture_astc WEBGL_compressed_texture_etc WEBGL_compressed_texture_etc1 WEBGL_compressed_texture_s3tc WEBGL_compressed_texture_s3tc_srgb WEBGL_debug_renderer_info WEBGL_debug_shaders WEBGL_lose_context WEBGL_multi_draw".split(" ");
  return (a.getSupportedExtensions() || []).filter(c => b.includes(c));
}, Ad = 1, Bd = [], V = [], Cd = [], Dd = [], Ed = [], Fd = [], Gd = [], v = [], Hd = {}, Id = 4, Jd = 0, Kd = a => {
  for (var b = Ad++, c = a.length; c < b; c++) {
    a[c] = null;
  }
  return b;
}, Ld = (a, b, c, d) => {
  for (var e = 0; e < a; e++) {
    var f = W[c](), g = f && Kd(d);
    f ? (f.name = g, d[g] = f) : X ||= 1282;
    F[b + 4 * e >> 2] = g;
  }
}, la = (a, b) => {
  var c = Kd(v), d = {handle:c, attributes:b, version:b.Ac, C:a};
  a.canvas && (a.canvas.qb = d);
  v[c] = d;
  ("undefined" == typeof b.Bb || b.Bb) && Md(d);
  return c;
}, ka = a => {
  p = v[a];
  k.rc = W = p?.C;
  return !(a && !W);
}, Md = a => {
  a ||= p;
  if (!a.Lb) {
    a.Lb = !0;
    var b = a.C;
    xd(b);
    yd(b);
    2 <= a.version && (b.Wa = b.getExtension("EXT_disjoint_timer_query_webgl2"));
    if (2 > a.version || !b.Wa) {
      b.Wa = b.getExtension("EXT_disjoint_timer_query");
    }
    b.Rb = b.getExtension("WEBGL_multi_draw");
    zd(b).forEach(c => {
      c.includes("lose_context") || c.includes("debug") || b.getExtension(c);
    });
  }
}, X, p, Nd = {}, Pd = () => {
  if (!Od) {
    var a = {USER:"web_user", LOGNAME:"web_user", PATH:"/", PWD:"/", HOME:"/home/web_user", LANG:("object" == typeof navigator && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", _:na || "./this.program"}, b;
    for (b in Nd) {
      void 0 === Nd[b] ? delete a[b] : a[b] = Nd[b];
    }
    var c = [];
    for (b in a) {
      c.push(`${b}=${a[b]}`);
    }
    Od = c;
  }
  return Od;
}, Od, Qd = [];
function Rd() {
  var a = zd(W);
  return a = a.concat(a.map(b => "GL_" + b));
}
var Sd = (a, b) => {
  if (b) {
    var c = void 0;
    switch(a) {
      case 36346:
        c = 1;
        break;
      case 36344:
        return;
      case 34814:
      case 36345:
        c = 0;
        break;
      case 34466:
        var d = W.getParameter(34467);
        c = d ? d.length : 0;
        break;
      case 33309:
        if (2 > p.version) {
          X ||= 1282;
          return;
        }
        c = Rd().length;
        break;
      case 33307:
      case 33308:
        if (2 > p.version) {
          X ||= 1280;
          return;
        }
        c = 33307 == a ? 3 : 0;
    }
    if (void 0 === c) {
      switch(d = W.getParameter(a), typeof d) {
        case "number":
          c = d;
          break;
        case "boolean":
          c = d ? 1 : 0;
          break;
        case "string":
          X ||= 1280;
          return;
        case "object":
          if (null === d) {
            switch(a) {
              case 34964:
              case 35725:
              case 34965:
              case 36006:
              case 36007:
              case 32873:
              case 34229:
              case 36662:
              case 36663:
              case 35053:
              case 35055:
              case 36010:
              case 35097:
              case 35869:
              case 32874:
              case 36389:
              case 35983:
              case 35368:
              case 34068:
                c = 0;
                break;
              default:
                X ||= 1280;
                return;
            }
          } else {
            if (d instanceof Float32Array || d instanceof Uint32Array || d instanceof Int32Array || d instanceof Array) {
              for (a = 0; a < d.length; ++a) {
                F[b + 4 * a >> 2] = d[a];
              }
              return;
            }
            try {
              c = d.name | 0;
            } catch (e) {
              X ||= 1280;
              A(`GL_INVALID_ENUM in glGet${0}v: Unknown object returned from WebGL getParameter(${a})! (error: ${e})`);
              return;
            }
          }
          break;
        default:
          X ||= 1280;
          A(`GL_INVALID_ENUM in glGet${0}v: Native code calling glGet${0}v(${a}) and it returns ${d} of type ${typeof d}!`);
          return;
      }
    }
    F[b >> 2] = c;
  } else {
    X ||= 1281;
  }
}, Ud = a => {
  var b = eb(a) + 1, c = Td(b);
  c && fb(a, D, c, b);
  return c;
}, Vd = a => "]" == a.slice(-1) && a.lastIndexOf("["), Wd = a => {
  a -= 5120;
  return 0 == a ? C : 1 == a ? D : 2 == a ? E : 4 == a ? F : 6 == a ? wa : 5 == a || 28922 == a || 28520 == a || 30779 == a || 30782 == a ? K : va;
}, Xd = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Yd = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Zd = (a, b, c, d) => {
  function e(n, q, t) {
    for (n = "number" == typeof n ? n.toString() : n || ""; n.length < q;) {
      n = t[0] + n;
    }
    return n;
  }
  function f(n, q) {
    return e(n, q, "0");
  }
  function g(n, q) {
    function t(z) {
      return 0 > z ? -1 : 0 < z ? 1 : 0;
    }
    var y;
    0 === (y = t(n.getFullYear() - q.getFullYear())) && 0 === (y = t(n.getMonth() - q.getMonth())) && (y = t(n.getDate() - q.getDate()));
    return y;
  }
  function h(n) {
    switch(n.getDay()) {
      case 0:
        return new Date(n.getFullYear() - 1, 11, 29);
      case 1:
        return n;
      case 2:
        return new Date(n.getFullYear(), 0, 3);
      case 3:
        return new Date(n.getFullYear(), 0, 2);
      case 4:
        return new Date(n.getFullYear(), 0, 1);
      case 5:
        return new Date(n.getFullYear() - 1, 11, 31);
      case 6:
        return new Date(n.getFullYear() - 1, 11, 30);
    }
  }
  function m(n) {
    var q = n.$;
    for (n = new Date((new Date(n.aa + 1900, 0, 1)).getTime()); 0 < q;) {
      var t = n.getMonth(), y = (td(n.getFullYear()) ? Xd : Yd)[t];
      if (q > y - n.getDate()) {
        q -= y - n.getDate() + 1, n.setDate(1), 11 > t ? n.setMonth(t + 1) : (n.setMonth(0), n.setFullYear(n.getFullYear() + 1));
      } else {
        n.setDate(n.getDate() + q);
        break;
      }
    }
    t = new Date(n.getFullYear() + 1, 0, 4);
    q = h(new Date(n.getFullYear(), 0, 4));
    t = h(t);
    return 0 >= g(q, n) ? 0 >= g(t, n) ? n.getFullYear() + 1 : n.getFullYear() : n.getFullYear() - 1;
  }
  var l = K[d + 40 >> 2];
  d = {ac:F[d >> 2], $b:F[d + 4 >> 2], Da:F[d + 8 >> 2], Pa:F[d + 12 >> 2], Ea:F[d + 16 >> 2], aa:F[d + 20 >> 2], N:F[d + 24 >> 2], $:F[d + 28 >> 2], Ic:F[d + 32 >> 2], Zb:F[d + 36 >> 2], bc:l ? l ? L(D, l) : "" : ""};
  c = c ? L(D, c) : "";
  l = {"%c":"%a %b %d %H:%M:%S %Y", "%D":"%m/%d/%y", "%F":"%Y-%m-%d", "%h":"%b", "%r":"%I:%M:%S %p", "%R":"%H:%M", "%T":"%H:%M:%S", "%x":"%m/%d/%y", "%X":"%H:%M:%S", "%Ec":"%c", "%EC":"%C", "%Ex":"%m/%d/%y", "%EX":"%H:%M:%S", "%Ey":"%y", "%EY":"%Y", "%Od":"%d", "%Oe":"%e", "%OH":"%H", "%OI":"%I", "%Om":"%m", "%OM":"%M", "%OS":"%S", "%Ou":"%u", "%OU":"%U", "%OV":"%V", "%Ow":"%w", "%OW":"%W", "%Oy":"%y",};
  for (var r in l) {
    c = c.replace(new RegExp(r, "g"), l[r]);
  }
  var u = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "), w = "January February March April May June July August September October November December".split(" ");
  l = {"%a":n => u[n.N].substring(0, 3), "%A":n => u[n.N], "%b":n => w[n.Ea].substring(0, 3), "%B":n => w[n.Ea], "%C":n => f((n.aa + 1900) / 100 | 0, 2), "%d":n => f(n.Pa, 2), "%e":n => e(n.Pa, 2, " "), "%g":n => m(n).toString().substring(2), "%G":m, "%H":n => f(n.Da, 2), "%I":n => {
    n = n.Da;
    0 == n ? n = 12 : 12 < n && (n -= 12);
    return f(n, 2);
  }, "%j":n => {
    for (var q = 0, t = 0; t <= n.Ea - 1; q += (td(n.aa + 1900) ? Xd : Yd)[t++]) {
    }
    return f(n.Pa + q, 3);
  }, "%m":n => f(n.Ea + 1, 2), "%M":n => f(n.$b, 2), "%n":() => "\n", "%p":n => 0 <= n.Da && 12 > n.Da ? "AM" : "PM", "%S":n => f(n.ac, 2), "%t":() => "\t", "%u":n => n.N || 7, "%U":n => f(Math.floor((n.$ + 7 - n.N) / 7), 2), "%V":n => {
    var q = Math.floor((n.$ + 7 - (n.N + 6) % 7) / 7);
    2 >= (n.N + 371 - n.$ - 2) % 7 && q++;
    if (q) {
      53 == q && (t = (n.N + 371 - n.$) % 7, 4 == t || 3 == t && td(n.aa) || (q = 1));
    } else {
      q = 52;
      var t = (n.N + 7 - n.$ - 1) % 7;
      (4 == t || 5 == t && td(n.aa % 400 - 1)) && q++;
    }
    return f(q, 2);
  }, "%w":n => n.N, "%W":n => f(Math.floor((n.$ + 7 - (n.N + 6) % 7) / 7), 2), "%y":n => (n.aa + 1900).toString().substring(2), "%Y":n => n.aa + 1900, "%z":n => {
    n = n.Zb;
    var q = 0 <= n;
    n = Math.abs(n) / 60;
    return (q ? "+" : "-") + String("0000" + (n / 60 * 100 + n % 60)).slice(-4);
  }, "%Z":n => n.bc, "%%":() => "%"};
  c = c.replace(/%%/g, "\x00\x00");
  for (r in l) {
    c.includes(r) && (c = c.replace(new RegExp(r, "g"), l[r](d)));
  }
  c = c.replace(/\0\0/g, "%");
  r = gb(c, !1);
  if (r.length > b) {
    return 0;
  }
  C.set(r, a);
  return r.length - 1;
};
[44].forEach(a => {
  rb[a] = new M(a);
  rb[a].stack = "<generic error, no stack>";
});
yb = Array(4096);
Mb(N, "/");
Ob("/tmp");
Ob("/home");
Ob("/home/web_user");
(function() {
  Ob("/dev");
  jb(259, {read:() => 0, write:(d, e, f, g) => g,});
  Pb("/dev/null", 259);
  ib(1280, lb);
  ib(1536, mb);
  Pb("/dev/tty", 1280);
  Pb("/dev/tty1", 1536);
  var a = new Uint8Array(1024), b = 0, c = () => {
    0 === b && (b = ab(a).byteLength);
    return a[--b];
  };
  Vb("random", c);
  Vb("urandom", c);
  Ob("/dev/shm");
  Ob("/dev/shm/tmp");
})();
(function() {
  Ob("/proc");
  var a = Ob("/proc/self");
  Ob("/proc/self/fd");
  Mb({R() {
    var b = qb(a, "fd", 16895, 73);
    b.i = {ha(c, d) {
      var e = Jb(+d);
      c = {parent:null, R:{cb:"fake"}, i:{ia:() => e.path},};
      return c.parent = c;
    }};
    return b;
  }}, "/proc/self/fd");
})();
P = k.BindingError = class extends Error {
  constructor(a) {
    super(a);
    this.name = "BindingError";
  }
};
O.push(0, 1, void 0, 1, null, 1, !0, 1, !1, 1,);
k.count_emval_handles = () => O.length / 2 - 5 - Zb.length;
bc = k.PureVirtualError = ac("PureVirtualError");
for (var $d = Array(256), ae = 0; 256 > ae; ++ae) {
  $d[ae] = String.fromCharCode(ae);
}
cc = $d;
k.getInheritedInstanceCount = () => Object.keys(gc).length;
k.getLiveInheritedInstances = () => {
  var a = [], b;
  for (b in gc) {
    gc.hasOwnProperty(b) && a.push(gc[b]);
  }
  return a;
};
k.flushPendingDeletes = ec;
k.setDelayFunction = a => {
  fc = a;
  dc.length && fc && fc(ec);
};
sc = k.InternalError = class extends Error {
  constructor(a) {
    super(a);
    this.name = "InternalError";
  }
};
Object.assign(Cc.prototype, {isAliasOf:function(a) {
  if (!(this instanceof Cc && a instanceof Cc)) {
    return !1;
  }
  var b = this.g.s.h, c = this.g.m;
  a.g = a.g;
  var d = a.g.s.h;
  for (a = a.g.m; b.A;) {
    c = b.ka(c), b = b.A;
  }
  for (; d.A;) {
    a = d.ka(a), d = d.A;
  }
  return b === d && c === a;
}, clone:function() {
  this.g.m || Bc(this);
  if (this.g.fa) {
    return this.g.count.value += 1, this;
  }
  var a = tc, b = Object, c = b.create, d = Object.getPrototypeOf(this), e = this.g;
  a = a(c.call(b, d, {g:{value:{count:e.count, ea:e.ea, fa:e.fa, m:e.m, s:e.s, B:e.B, G:e.G,},}}));
  a.g.count.value += 1;
  a.g.ea = !1;
  return a;
}, ["delete"]() {
  this.g.m || Bc(this);
  if (this.g.ea && !this.g.fa) {
    throw new P("Object already scheduled for deletion");
  }
  nc(this);
  var a = this.g;
  --a.count.value;
  0 === a.count.value && (a.B ? a.G.L(a.B) : a.s.h.L(a.m));
  this.g.fa || (this.g.B = void 0, this.g.m = void 0);
}, isDeleted:function() {
  return !this.g.m;
}, deleteLater:function() {
  this.g.m || Bc(this);
  if (this.g.ea && !this.g.fa) {
    throw new P("Object already scheduled for deletion");
  }
  dc.push(this);
  1 === dc.length && fc && fc(ec);
  this.g.ea = !0;
  return this;
},});
Object.assign(Mc.prototype, {Gb(a) {
  this.jb && (a = this.jb(a));
  return a;
}, Va(a) {
  this.L?.(a);
}, argPackAdvance:8, readValueFromPointer:xc, fromWireType:function(a) {
  function b() {
    return this.ta ? uc(this.h.J, {s:this.Tb, m:c, G:this, B:a,}) : uc(this.h.J, {s:this, m:a,});
  }
  var c = this.Gb(a);
  if (!c) {
    return this.Va(a), null;
  }
  var d = rc(this.h, c);
  if (void 0 !== d) {
    if (0 === d.g.count.value) {
      return d.g.m = c, d.g.B = a, d.clone();
    }
    d = d.clone();
    this.Va(a);
    return d;
  }
  d = this.h.Fb(c);
  d = qc[d];
  if (!d) {
    return b.call(this);
  }
  d = this.sa ? d.yb : d.pointerType;
  var e = pc(c, this.h, d.h);
  return null === e ? b.call(this) : this.ta ? uc(d.h.J, {s:d, m:e, G:this, B:a,}) : uc(d.h.J, {s:d, m:e,});
},});
Tc = k.UnboundTypeError = ac("UnboundTypeError");
for (var W, be = 0; 32 > be; ++be) {
  Qd.push(Array(be));
}
var de = {__syscall_fcntl64:function(a, b, c) {
  Va = c;
  try {
    var d = Jb(a);
    switch(b) {
      case 0:
        var e = Ua();
        if (0 > e) {
          break;
        }
        for (; wb[e];) {
          e++;
        }
        return Lb(d, e).T;
      case 1:
      case 2:
        return 0;
      case 3:
        return d.flags;
      case 4:
        return e = Ua(), d.flags |= e, 0;
      case 12:
        return e = Ua(), E[e + 0 >> 1] = 2, 0;
      case 13:
      case 14:
        return 0;
    }
    return -28;
  } catch (f) {
    if ("undefined" == typeof Xb || "ErrnoError" !== f.name) {
      throw f;
    }
    return -f.Y;
  }
}, __syscall_ioctl:function(a, b, c) {
  Va = c;
  try {
    var d = Jb(a);
    switch(b) {
      case 21509:
        return d.o ? 0 : -59;
      case 21505:
        if (!d.o) {
          return -59;
        }
        if (d.o.S.Nb) {
          a = [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,];
          var e = Ua();
          F[e >> 2] = 25856;
          F[e + 4 >> 2] = 5;
          F[e + 8 >> 2] = 191;
          F[e + 12 >> 2] = 35387;
          for (var f = 0; 32 > f; f++) {
            C[e + f + 17] = a[f] || 0;
          }
        }
        return 0;
      case 21510:
      case 21511:
      case 21512:
        return d.o ? 0 : -59;
      case 21506:
      case 21507:
      case 21508:
        if (!d.o) {
          return -59;
        }
        if (d.o.S.Ob) {
          for (e = Ua(), a = [], f = 0; 32 > f; f++) {
            a.push(C[e + f + 17]);
          }
        }
        return 0;
      case 21519:
        if (!d.o) {
          return -59;
        }
        e = Ua();
        return F[e >> 2] = 0;
      case 21520:
        return d.o ? -28 : -59;
      case 21531:
        e = Ua();
        if (!d.l.Mb) {
          throw new M(59);
        }
        return d.l.Mb(d, b, e);
      case 21523:
        if (!d.o) {
          return -59;
        }
        d.o.S.Pb && (f = [24, 80], e = Ua(), E[e >> 1] = f[0], E[e + 2 >> 1] = f[1]);
        return 0;
      case 21524:
        return d.o ? 0 : -59;
      case 21515:
        return d.o ? 0 : -59;
      default:
        return -28;
    }
  } catch (g) {
    if ("undefined" == typeof Xb || "ErrnoError" !== g.name) {
      throw g;
    }
    return -g.Y;
  }
}, __syscall_openat:function(a, b, c, d) {
  Va = d;
  try {
    b = b ? L(D, b) : "";
    var e = b;
    if ("/" === e.charAt(0)) {
      b = e;
    } else {
      var f = -100 === a ? "/" : Jb(a).path;
      if (0 == e.length) {
        throw new M(44);
      }
      b = Xa(f + "/" + e);
    }
    var g = d ? Ua() : 0;
    return Rb(b, c, g).T;
  } catch (h) {
    if ("undefined" == typeof Xb || "ErrnoError" !== h.name) {
      throw h;
    }
    return -h.Y;
  }
}, _abort_js:() => {
  Ga("");
}, _embind_create_inheriting_constructor:(a, b, c) => {
  a = R(a);
  b = mc(b, "wrapper");
  c = Q(c);
  var d = b.h, e = d.J, f = d.A.J, g = d.A.constructor;
  a = Yb(a, function(...h) {
    d.A.hb.forEach(function(m) {
      if (this[m] === f[m]) {
        throw new bc(`Pure virtual function ${m} must be implemented in JavaScript`);
      }
    }.bind(this));
    Object.defineProperty(this, "__parent", {value:e});
    this.__construct(...h);
  });
  e.__construct = function(...h) {
    if (this === e) {
      throw new P("Pass correct 'this' to __construct");
    }
    h = g.implement(this, ...h);
    nc(h);
    var m = h.g;
    h.notifyOnDestruction();
    m.fa = !0;
    Object.defineProperties(this, {g:{value:m}});
    tc(this);
    h = m.m;
    h = hc(d, h);
    if (gc.hasOwnProperty(h)) {
      throw new P(`Tried to register registered instance: ${h}`);
    }
    gc[h] = this;
  };
  e.__destruct = function() {
    if (this === e) {
      throw new P("Pass correct 'this' to __destruct");
    }
    nc(this);
    var h = this.g.m;
    h = hc(d, h);
    if (gc.hasOwnProperty(h)) {
      delete gc[h];
    } else {
      throw new P(`Tried to unregister unregistered instance: ${h}`);
    }
  };
  a.prototype = Object.create(e);
  Object.assign(a.prototype, c);
  return $b(a);
}, _embind_finalize_value_object:a => {
  var b = vc[a];
  delete vc[a];
  var c = b.Na, d = b.L, e = b.Xa, f = e.map(g => g.Jb).concat(e.map(g => g.Wb));
  T([a], f, g => {
    var h = {};
    e.forEach((m, l) => {
      var r = g[l], u = m.Hb, w = m.Ib, n = g[l + e.length], q = m.Vb, t = m.Xb;
      h[m.Db] = {read:y => r.fromWireType(u(w, y)), write:(y, z) => {
        var B = [];
        q(t, y, n.toWireType(B, z));
        wc(B);
      }};
    });
    return [{name:b.name, fromWireType:m => {
      var l = {}, r;
      for (r in h) {
        l[r] = h[r].read(m);
      }
      d(m);
      return l;
    }, toWireType:(m, l) => {
      for (var r in h) {
        if (!(r in l)) {
          throw new TypeError(`Missing field: "${r}"`);
        }
      }
      var u = c();
      for (r in h) {
        h[r].write(u, l[r]);
      }
      null !== m && m.push(d, u);
      return u;
    }, argPackAdvance:8, readValueFromPointer:xc, I:d,}];
  });
}, _embind_register_bigint:() => {
}, _embind_register_bool:(a, b, c, d) => {
  b = R(b);
  S(a, {name:b, fromWireType:function(e) {
    return !!e;
  }, toWireType:function(e, f) {
    return f ? c : d;
  }, argPackAdvance:8, readValueFromPointer:function(e) {
    return this.fromWireType(D[e]);
  }, I:null,});
}, _embind_register_class:(a, b, c, d, e, f, g, h, m, l, r, u, w) => {
  r = R(r);
  f = U(e, f);
  h &&= U(g, h);
  l &&= U(m, l);
  w = U(u, w);
  var n = Fc(r);
  Ec(n, function() {
    Uc(`Cannot construct ${r} due to unbound types`, [d]);
  });
  T([a, b, c], d ? [d] : [], q => {
    q = q[0];
    if (d) {
      var t = q.h;
      var y = t.J;
    } else {
      y = Cc.prototype;
    }
    q = Yb(r, function(...I) {
      if (Object.getPrototypeOf(this) !== z) {
        throw new P("Use 'new' to construct " + r);
      }
      if (void 0 === B.X) {
        throw new P(r + " has no accessible constructor");
      }
      var J = B.X[I.length];
      if (void 0 === J) {
        throw new P(`Tried to invoke ctor of ${r} with invalid number of parameters (${I.length}) - expected (${Object.keys(B.X).toString()}) parameters instead!`);
      }
      return J.apply(this, I);
    });
    var z = Object.create(y, {constructor:{value:q},});
    q.prototype = z;
    var B = new Gc(r, q, z, w, t, f, h, l);
    if (B.A) {
      var G;
      (G = B.A).la ?? (G.la = []);
      B.A.la.push(B);
    }
    t = new Mc(r, B, !0, !1, !1);
    G = new Mc(r + "*", B, !1, !1, !1);
    y = new Mc(r + " const*", B, !1, !0, !1);
    qc[a] = {pointerType:G, yb:y};
    Nc(n, q);
    return [t, G, y];
  });
}, _embind_register_class_class_function:(a, b, c, d, e, f, g) => {
  var h = Xc(c, d);
  b = R(b);
  b = Yc(b);
  f = U(e, f);
  T([], [a], m => {
    function l() {
      Uc(`Cannot call ${r} due to unbound types`, h);
    }
    m = m[0];
    var r = `${m.name}.${b}`;
    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
    var u = m.h.constructor;
    void 0 === u[b] ? (l.da = c - 1, u[b] = l) : (Dc(u, b, r), u[b].v[c - 1] = l);
    T([], h, w => {
      w = Wc(r, [w[0], null].concat(w.slice(1)), null, f, g);
      void 0 === u[b].v ? (w.da = c - 1, u[b] = w) : u[b].v[c - 1] = w;
      if (m.h.la) {
        for (const n of m.h.la) {
          n.constructor.hasOwnProperty(b) || (n.constructor[b] = w);
        }
      }
      return [];
    });
    return [];
  });
}, _embind_register_class_class_property:(a, b, c, d, e, f, g, h) => {
  b = R(b);
  f = U(e, f);
  T([], [a], m => {
    m = m[0];
    var l = `${m.name}.${b}`, r = {get() {
      Uc(`Cannot access ${l} due to unbound types`, [c]);
    }, enumerable:!0, configurable:!0};
    r.set = h ? () => {
      Uc(`Cannot access ${l} due to unbound types`, [c]);
    } : () => {
      throw new P(`${l} is a read-only property`);
    };
    Object.defineProperty(m.h.constructor, b, r);
    T([], [c], u => {
      u = u[0];
      var w = {get() {
        return u.fromWireType(f(d));
      }, enumerable:!0};
      h && (h = U(g, h), w.set = n => {
        var q = [];
        h(d, u.toWireType(q, n));
        wc(q);
      });
      Object.defineProperty(m.h.constructor, b, w);
      return [];
    });
    return [];
  });
}, _embind_register_class_constructor:(a, b, c, d, e, f) => {
  var g = Xc(b, c);
  e = U(d, e);
  T([], [a], h => {
    h = h[0];
    var m = `constructor ${h.name}`;
    void 0 === h.h.X && (h.h.X = []);
    if (void 0 !== h.h.X[b - 1]) {
      throw new P(`Cannot register multiple constructors with identical number of parameters (${b - 1}) for class '${h.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
    }
    h.h.X[b - 1] = () => {
      Uc(`Cannot construct ${h.name} due to unbound types`, g);
    };
    T([], g, l => {
      l.splice(1, 0, null);
      h.h.X[b - 1] = Wc(m, l, null, e, f);
      return [];
    });
    return [];
  });
}, _embind_register_class_function:(a, b, c, d, e, f, g, h) => {
  var m = Xc(c, d);
  b = R(b);
  b = Yc(b);
  f = U(e, f);
  T([], [a], l => {
    function r() {
      Uc(`Cannot call ${u} due to unbound types`, m);
    }
    l = l[0];
    var u = `${l.name}.${b}`;
    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
    h && l.h.hb.push(b);
    var w = l.h.J, n = w[b];
    void 0 === n || void 0 === n.v && n.className !== l.name && n.da === c - 2 ? (r.da = c - 2, r.className = l.name, w[b] = r) : (Dc(w, b, u), w[b].v[c - 2] = r);
    T([], m, q => {
      q = Wc(u, q, l, f, g);
      void 0 === w[b].v ? (q.da = c - 2, w[b] = q) : w[b].v[c - 2] = q;
      return [];
    });
    return [];
  });
}, _embind_register_class_property:(a, b, c, d, e, f, g, h, m, l) => {
  b = R(b);
  e = U(d, e);
  T([], [a], r => {
    r = r[0];
    var u = `${r.name}.${b}`, w = {get() {
      Uc(`Cannot access ${u} due to unbound types`, [c, g]);
    }, enumerable:!0, configurable:!0};
    w.set = m ? () => Uc(`Cannot access ${u} due to unbound types`, [c, g]) : () => {
      throw new P(u + " is a read-only property");
    };
    Object.defineProperty(r.h.J, b, w);
    T([], m ? [c, g] : [c], n => {
      var q = n[0], t = {get() {
        var z = Zc(this, r, u + " getter");
        return q.fromWireType(e(f, z));
      }, enumerable:!0};
      if (m) {
        m = U(h, m);
        var y = n[1];
        t.set = function(z) {
          var B = Zc(this, r, u + " setter"), G = [];
          m(l, B, y.toWireType(G, z));
          wc(G);
        };
      }
      Object.defineProperty(r.h.J, b, t);
      return [];
    });
    return [];
  });
}, _embind_register_emval:a => S(a, ad), _embind_register_enum:(a, b, c, d) => {
  function e() {
  }
  b = R(b);
  e.values = {};
  S(a, {name:b, constructor:e, fromWireType:function(f) {
    return this.constructor.values[f];
  }, toWireType:(f, g) => g.value, argPackAdvance:8, readValueFromPointer:bd(b, c, d), I:null,});
  Ec(b, e);
}, _embind_register_enum_value:(a, b, c) => {
  var d = mc(a, "enum");
  b = R(b);
  a = d.constructor;
  d = Object.create(d.constructor.prototype, {value:{value:c}, constructor:{value:Yb(`${d.name}_${b}`, function() {
  })},});
  a.values[c] = d;
  a[b] = d;
}, _embind_register_float:(a, b, c) => {
  b = R(b);
  S(a, {name:b, fromWireType:d => d, toWireType:(d, e) => e, argPackAdvance:8, readValueFromPointer:cd(b, c), I:null,});
}, _embind_register_function:(a, b, c, d, e, f) => {
  var g = Xc(b, c);
  a = R(a);
  a = Yc(a);
  e = U(d, e);
  Ec(a, function() {
    Uc(`Cannot call ${a} due to unbound types`, g);
  }, b - 1);
  T([], g, h => {
    Nc(a, Wc(a, [h[0], null].concat(h.slice(1)), null, e, f), b - 1);
    return [];
  });
}, _embind_register_integer:(a, b, c, d, e) => {
  b = R(b);
  -1 === e && (e = 4294967295);
  e = h => h;
  if (0 === d) {
    var f = 32 - 8 * c;
    e = h => h << f >>> f;
  }
  var g = b.includes("unsigned") ? function(h, m) {
    return m >>> 0;
  } : function(h, m) {
    return m;
  };
  S(a, {name:b, fromWireType:e, toWireType:g, argPackAdvance:8, readValueFromPointer:dd(b, c, 0 !== d), I:null,});
}, _embind_register_memory_view:(a, b, c) => {
  function d(f) {
    return new e(C.buffer, K[f + 4 >> 2], K[f >> 2]);
  }
  var e = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array,][b];
  c = R(c);
  S(a, {name:c, fromWireType:d, argPackAdvance:8, readValueFromPointer:d,}, {Kb:!0,});
}, _embind_register_std_string:(a, b) => {
  b = R(b);
  var c = "std::string" === b;
  S(a, {name:b, fromWireType:function(d) {
    var e = K[d >> 2], f = d + 4;
    if (c) {
      for (var g = f, h = 0; h <= e; ++h) {
        var m = f + h;
        if (h == e || 0 == D[m]) {
          g = g ? L(D, g, m - g) : "";
          if (void 0 === l) {
            var l = g;
          } else {
            l += String.fromCharCode(0), l += g;
          }
          g = m + 1;
        }
      }
    } else {
      l = Array(e);
      for (h = 0; h < e; ++h) {
        l[h] = String.fromCharCode(D[f + h]);
      }
      l = l.join("");
    }
    kc(d);
    return l;
  }, toWireType:function(d, e) {
    e instanceof ArrayBuffer && (e = new Uint8Array(e));
    var f = "string" == typeof e;
    if (!(f || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int8Array)) {
      throw new P("Cannot pass non-string to std::string");
    }
    var g = c && f ? eb(e) : e.length;
    var h = Td(4 + g + 1), m = h + 4;
    K[h >> 2] = g;
    if (c && f) {
      fb(e, D, m, g + 1);
    } else {
      if (f) {
        for (f = 0; f < g; ++f) {
          var l = e.charCodeAt(f);
          if (255 < l) {
            throw kc(m), new P("String has UTF-16 code units that do not fit in 8 bits");
          }
          D[m + f] = l;
        }
      } else {
        for (f = 0; f < g; ++f) {
          D[m + f] = e[f];
        }
      }
    }
    null !== d && d.push(kc, h);
    return h;
  }, argPackAdvance:8, readValueFromPointer:xc, I(d) {
    kc(d);
  },});
}, _embind_register_std_wstring:(a, b, c) => {
  c = R(c);
  if (2 === b) {
    var d = fd;
    var e = gd;
    var f = hd;
    var g = h => va[h >> 1];
  } else {
    4 === b && (d = jd, e = kd, f = ld, g = h => K[h >> 2]);
  }
  S(a, {name:c, fromWireType:h => {
    for (var m = K[h >> 2], l, r = h + 4, u = 0; u <= m; ++u) {
      var w = h + 4 + u * b;
      if (u == m || 0 == g(w)) {
        r = d(r, w - r), void 0 === l ? l = r : (l += String.fromCharCode(0), l += r), r = w + b;
      }
    }
    kc(h);
    return l;
  }, toWireType:(h, m) => {
    if ("string" != typeof m) {
      throw new P(`Cannot pass non-string to C++ string type ${c}`);
    }
    var l = f(m), r = Td(4 + l + b);
    K[r >> 2] = l / b;
    e(m, r + 4, l + b);
    null !== h && h.push(kc, r);
    return r;
  }, argPackAdvance:8, readValueFromPointer:xc, I(h) {
    kc(h);
  }});
}, _embind_register_value_object:(a, b, c, d, e, f) => {
  vc[a] = {name:R(b), Na:U(c, d), L:U(e, f), Xa:[],};
}, _embind_register_value_object_field:(a, b, c, d, e, f, g, h, m, l) => {
  vc[a].Xa.push({Db:R(b), Jb:c, Hb:U(d, e), Ib:f, Wb:g, Vb:U(h, m), Xb:l,});
}, _embind_register_void:(a, b) => {
  b = R(b);
  S(a, {yc:!0, name:b, argPackAdvance:0, fromWireType:() => {
  }, toWireType:() => {
  },});
}, _emscripten_get_now_is_monotonic:() => 1, _emscripten_memcpy_js:(a, b, c) => D.copyWithin(a, b, b + c), _emscripten_throw_longjmp:() => {
  throw Infinity;
}, _emval_as:(a, b, c) => {
  a = Q(a);
  b = mc(b, "emval::as");
  return md(b, c, a);
}, _emval_call:(a, b, c, d) => {
  a = nd[a];
  b = Q(b);
  return a(null, b, c, d);
}, _emval_call_method:(a, b, c, d, e) => {
  a = nd[a];
  b = Q(b);
  c = pd(c);
  return a(b, b[c], d, e);
}, _emval_decref:$c, _emval_get_method_caller:(a, b, c) => {
  var d = rd(a, b), e = d.shift();
  a--;
  var f = Array(a);
  b = `methodCaller<(${d.map(g => g.name).join(", ")}) => ${e.name}>`;
  return qd(Yb(b, (g, h, m, l) => {
    for (var r = 0, u = 0; u < a; ++u) {
      f[u] = d[u].readValueFromPointer(l + r), r += d[u].argPackAdvance;
    }
    g = 1 === c ? sd(h, f) : h.apply(g, f);
    return md(e, m, g);
  }));
}, _emval_get_property:(a, b) => {
  a = Q(a);
  b = Q(b);
  return $b(a[b]);
}, _emval_incref:a => {
  9 < a && (O[a + 1] += 1);
}, _emval_new_array:() => $b([]), _emval_new_cstring:a => $b(pd(a)), _emval_new_object:() => $b({}), _emval_run_destructors:a => {
  var b = Q(a);
  wc(b);
  $c(a);
}, _emval_set_property:(a, b, c) => {
  a = Q(a);
  b = Q(b);
  c = Q(c);
  a[b] = c;
}, _emval_take_value:(a, b) => {
  a = mc(a, "_emval_take_value");
  a = a.readValueFromPointer(b);
  return $b(a);
}, _gmtime_js:function(a, b, c) {
  a = new Date(1000 * (b + 2097152 >>> 0 < 4194305 - !!a ? (a >>> 0) + 4294967296 * b : NaN));
  F[c >> 2] = a.getUTCSeconds();
  F[c + 4 >> 2] = a.getUTCMinutes();
  F[c + 8 >> 2] = a.getUTCHours();
  F[c + 12 >> 2] = a.getUTCDate();
  F[c + 16 >> 2] = a.getUTCMonth();
  F[c + 20 >> 2] = a.getUTCFullYear() - 1900;
  F[c + 24 >> 2] = a.getUTCDay();
  F[c + 28 >> 2] = (a.getTime() - Date.UTC(a.getUTCFullYear(), 0, 1, 0, 0, 0, 0)) / 864E5 | 0;
}, _localtime_js:function(a, b, c) {
  a = new Date(1000 * (b + 2097152 >>> 0 < 4194305 - !!a ? (a >>> 0) + 4294967296 * b : NaN));
  F[c >> 2] = a.getSeconds();
  F[c + 4 >> 2] = a.getMinutes();
  F[c + 8 >> 2] = a.getHours();
  F[c + 12 >> 2] = a.getDate();
  F[c + 16 >> 2] = a.getMonth();
  F[c + 20 >> 2] = a.getFullYear() - 1900;
  F[c + 24 >> 2] = a.getDay();
  F[c + 28 >> 2] = (td(a.getFullYear()) ? ud : vd)[a.getMonth()] + a.getDate() - 1 | 0;
  F[c + 36 >> 2] = -(60 * a.getTimezoneOffset());
  b = (new Date(a.getFullYear(), 6, 1)).getTimezoneOffset();
  var d = (new Date(a.getFullYear(), 0, 1)).getTimezoneOffset();
  F[c + 32 >> 2] = (b != d && a.getTimezoneOffset() == Math.min(d, b)) | 0;
}, _tzset_js:(a, b, c, d) => {
  var e = (new Date()).getFullYear(), f = new Date(e, 0, 1), g = new Date(e, 6, 1);
  e = f.getTimezoneOffset();
  var h = g.getTimezoneOffset();
  K[a >> 2] = 60 * Math.max(e, h);
  F[b >> 2] = Number(e != h);
  a = m => m.toLocaleTimeString(void 0, {hour12:!1, timeZoneName:"short"}).split(" ")[1];
  f = a(f);
  g = a(g);
  h < e ? (fb(f, D, c, 17), fb(g, D, d, 17)) : (fb(f, D, d, 17), fb(g, D, c, 17));
}, beginPixelLocalStorageWEBGL:function(a, b, c) {
  (a = v[a].C.za) && a.beginPixelLocalStorageWEBGL(k.HEAPU32.subarray(c, c + b));
}, decode_image:function(a, b, c) {
  var d = k.images;
  d || (d = new Map(), k.images = d);
  var e = new Image();
  d.set(a, e);
  b = k.HEAP8.subarray(b, b + c);
  c = new Uint8Array(c);
  c.set(b);
  e.src = URL.createObjectURL(new Blob([c], {type:"image/png"}));
  e.onload = function() {
    k._setWebImage(a, e.width, e.height);
  };
}, delete_image:function(a) {
  var b = k.images;
  b && b.get(a) && b.delete(a);
}, emscripten_asm_const_int:(a, b, c) => {
  wd.length = 0;
  for (var d; d = D[b++];) {
    var e = 105 != d;
    e &= 112 != d;
    c += e && c % 8 ? 4 : 0;
    wd.push(112 == d ? K[c >> 2] : 105 == d ? F[c >> 2] : xa[c >> 3]);
    c += e ? 8 : 4;
  }
  return Sa[a](...wd);
}, emscripten_date_now:() => Date.now(), emscripten_get_now:() => performance.now(), emscripten_resize_heap:a => {
  var b = D.length;
  a >>>= 0;
  if (2147483648 < a) {
    return !1;
  }
  for (var c = 1; 4 >= c; c *= 2) {
    var d = b * (1 + 0.2 / c);
    d = Math.min(d, a + 100663296);
    var e = Math;
    d = Math.max(a, d);
    a: {
      e = (e.min.call(e, 2147483648, d + (65536 - d % 65536) % 65536) - ta.buffer.byteLength + 65535) / 65536;
      try {
        ta.grow(e);
        ya();
        var f = 1;
        break a;
      } catch (g) {
      }
      f = void 0;
    }
    if (f) {
      return !0;
    }
  }
  return !1;
}, emscripten_webgl_enable_extension:(a, b) => {
  a = v[a];
  b = b ? L(D, b) : "";
  b.startsWith("GL_") && (b = b.substr(3));
  "WEBGL_draw_instanced_base_vertex_base_instance" == b && xd(W);
  "WEBGL_multi_draw_instanced_base_vertex_base_instance" == b && yd(W);
  "WEBGL_multi_draw" == b && (W.Rb = W.getExtension("WEBGL_multi_draw"));
  return !!a.C.getExtension(b);
}, emscripten_webgl_get_current_context:() => p ? p.handle : 0, emscripten_webgl_make_context_current:a => ka(a) ? 0 : -5, enable_WEBGL_provoking_vertex:function(a) {
  a = v[a].C;
  a.ib = a.getExtension("WEBGL_provoking_vertex");
  return !!a.ib;
}, enable_WEBGL_shader_pixel_local_storage_coherent:function(a) {
  a = v[a].C;
  const b = a.getExtension("WEBGL_shader_pixel_local_storage");
  if (b && b.isCoherent()) {
    if (5 == b.framebufferTexturePixelLocalStorageWEBGL.length) {
      return a.za = b, !0;
    }
    console.warn("WEBGL_shader_pixel_local_storage is advertised, but a deprecated version has been detected. Disabling.");
  }
  return !1;
}, endPixelLocalStorageWEBGL:function(a, b, c) {
  (a = v[a].C.za) && a.endPixelLocalStorageWEBGL(k.HEAPU32.subarray(c, c + b));
}, environ_get:(a, b) => {
  var c = 0;
  Pd().forEach((d, e) => {
    var f = b + c;
    e = K[a + 4 * e >> 2] = f;
    for (f = 0; f < d.length; ++f) {
      C[e++] = d.charCodeAt(f);
    }
    C[e] = 0;
    c += d.length + 1;
  });
  return 0;
}, environ_sizes_get:(a, b) => {
  var c = Pd();
  K[a >> 2] = c.length;
  var d = 0;
  c.forEach(e => d += e.length + 1);
  K[b >> 2] = d;
  return 0;
}, fd_close:function(a) {
  try {
    var b = Jb(a);
    if (null === b.T) {
      throw new M(8);
    }
    b.Ka && (b.Ka = null);
    try {
      b.l.close && b.l.close(b);
    } catch (c) {
      throw c;
    } finally {
      wb[b.T] = null;
    }
    b.T = null;
    return 0;
  } catch (c) {
    if ("undefined" == typeof Xb || "ErrnoError" !== c.name) {
      throw c;
    }
    return c.Y;
  }
}, fd_read:function(a, b, c, d) {
  try {
    a: {
      var e = Jb(a);
      a = b;
      for (var f, g = b = 0; g < c; g++) {
        var h = K[a >> 2], m = K[a + 4 >> 2];
        a += 8;
        var l = e, r = f, u = C;
        if (0 > m || 0 > r) {
          throw new M(28);
        }
        if (null === l.T) {
          throw new M(8);
        }
        if (1 === (l.flags & 2097155)) {
          throw new M(8);
        }
        if (16384 === (l.node.mode & 61440)) {
          throw new M(31);
        }
        if (!l.l.read) {
          throw new M(28);
        }
        var w = "undefined" != typeof r;
        if (!w) {
          r = l.position;
        } else if (!l.seekable) {
          throw new M(70);
        }
        var n = l.l.read(l, u, h, m, r);
        w || (l.position += n);
        var q = n;
        if (0 > q) {
          var t = -1;
          break a;
        }
        b += q;
        if (q < m) {
          break;
        }
        "undefined" != typeof f && (f += q);
      }
      t = b;
    }
    K[d >> 2] = t;
    return 0;
  } catch (y) {
    if ("undefined" == typeof Xb || "ErrnoError" !== y.name) {
      throw y;
    }
    return y.Y;
  }
}, fd_seek:function(a, b, c, d, e) {
  b = c + 2097152 >>> 0 < 4194305 - !!b ? (b >>> 0) + 4294967296 * c : NaN;
  try {
    if (isNaN(b)) {
      return 61;
    }
    var f = Jb(a);
    Tb(f, b, d);
    Oa = [f.position >>> 0, (Na = f.position, 1.0 <= +Math.abs(Na) ? 0.0 < Na ? +Math.floor(Na / 4294967296.0) >>> 0 : ~~+Math.ceil((Na - +(~~Na >>> 0)) / 4294967296.0) >>> 0 : 0)];
    F[e >> 2] = Oa[0];
    F[e + 4 >> 2] = Oa[1];
    f.Ka && 0 === b && 0 === d && (f.Ka = null);
    return 0;
  } catch (g) {
    if ("undefined" == typeof Xb || "ErrnoError" !== g.name) {
      throw g;
    }
    return g.Y;
  }
}, fd_write:function(a, b, c, d) {
  try {
    a: {
      var e = Jb(a);
      a = b;
      for (var f, g = b = 0; g < c; g++) {
        var h = K[a >> 2], m = K[a + 4 >> 2];
        a += 8;
        var l = e, r = h, u = m, w = f, n = C;
        if (0 > u || 0 > w) {
          throw new M(28);
        }
        if (null === l.T) {
          throw new M(8);
        }
        if (0 === (l.flags & 2097155)) {
          throw new M(8);
        }
        if (16384 === (l.node.mode & 61440)) {
          throw new M(31);
        }
        if (!l.l.write) {
          throw new M(28);
        }
        l.seekable && l.flags & 1024 && Tb(l, 0, 2);
        var q = "undefined" != typeof w;
        if (!q) {
          w = l.position;
        } else if (!l.seekable) {
          throw new M(70);
        }
        var t = l.l.write(l, n, r, u, w, void 0);
        q || (l.position += t);
        var y = t;
        if (0 > y) {
          var z = -1;
          break a;
        }
        b += y;
        "undefined" != typeof f && (f += y);
      }
      z = b;
    }
    K[d >> 2] = z;
    return 0;
  } catch (B) {
    if ("undefined" == typeof Xb || "ErrnoError" !== B.name) {
      throw B;
    }
    return B.Y;
  }
}, framebufferPixelLocalClearValuefvWEBGL:function(a, b, c, d, e, f) {
  (a = v[a].C.za) && a.framebufferPixelLocalClearValuefvWEBGL(b, [c, d, e, f]);
}, framebufferTexturePixelLocalStorageWEBGL:function(a, b, c, d, e, f) {
  (a = v[a].C.za) && a.framebufferTexturePixelLocalStorageWEBGL(b, Ed[c], d, e, f);
}, glActiveTexture:a => W.activeTexture(a), glAttachShader:(a, b) => {
  W.attachShader(V[a], Fd[b]);
}, glBindBuffer:(a, b) => {
  35051 == a ? W.Ja = b : 35052 == a && (W.oa = b);
  W.bindBuffer(a, Bd[b]);
}, glBindBufferRange:(a, b, c, d, e) => {
  W.bindBufferRange(a, b, Bd[c], d, e);
}, glBindFramebuffer:(a, b) => {
  W.bindFramebuffer(a, Cd[b]);
}, glBindRenderbuffer:(a, b) => {
  W.bindRenderbuffer(a, Dd[b]);
}, glBindTexture:(a, b) => {
  W.bindTexture(a, Ed[b]);
}, glBindVertexArray:a => {
  W.bindVertexArray(Gd[a]);
}, glBlendEquation:a => W.blendEquation(a), glBlendFunc:(a, b) => W.blendFunc(a, b), glBlitFramebuffer:(a, b, c, d, e, f, g, h, m, l) => W.blitFramebuffer(a, b, c, d, e, f, g, h, m, l), glBufferData:(a, b, c, d) => {
  c && b ? W.bufferData(a, D, d, c, b) : W.bufferData(a, b, d);
}, glBufferSubData:(a, b, c, d) => {
  c && W.bufferSubData(a, b, D, d, c);
}, glClear:a => W.clear(a), glClearBufferfv:(a, b, c) => {
  W.clearBufferfv(a, b, wa, c >> 2);
}, glClearBufferuiv:(a, b, c) => {
  W.clearBufferuiv(a, b, K, c >> 2);
}, glClearColor:(a, b, c, d) => W.clearColor(a, b, c, d), glClearDepthf:a => W.clearDepth(a), glClearStencil:a => W.clearStencil(a), glColorMask:(a, b, c, d) => {
  W.colorMask(!!a, !!b, !!c, !!d);
}, glCompileShader:a => {
  W.compileShader(Fd[a]);
}, glCompressedTexSubImage2D:(a, b, c, d, e, f, g, h, m) => {
  W.oa || !h ? W.compressedTexSubImage2D(a, b, c, d, e, f, g, h, m) : W.compressedTexSubImage2D(a, b, c, d, e, f, g, D, m, h);
}, glCreateProgram:() => {
  var a = Kd(V), b = W.createProgram();
  b.name = a;
  b.wa = b.ua = b.va = 0;
  b.Qa = 1;
  V[a] = b;
  return a;
}, glCreateShader:a => {
  var b = Kd(Fd);
  Fd[b] = W.createShader(a);
  return b;
}, glCullFace:a => W.cullFace(a), glDeleteBuffers:(a, b) => {
  for (var c = 0; c < a; c++) {
    var d = F[b + 4 * c >> 2], e = Bd[d];
    e && (W.deleteBuffer(e), e.name = 0, Bd[d] = null, d == W.Ja && (W.Ja = 0), d == W.oa && (W.oa = 0));
  }
}, glDeleteFramebuffers:(a, b) => {
  for (var c = 0; c < a; ++c) {
    var d = F[b + 4 * c >> 2], e = Cd[d];
    e && (W.deleteFramebuffer(e), e.name = 0, Cd[d] = null);
  }
}, glDeleteProgram:a => {
  if (a) {
    var b = V[a];
    b ? (W.deleteProgram(b), b.name = 0, V[a] = null) : X ||= 1281;
  }
}, glDeleteRenderbuffers:(a, b) => {
  for (var c = 0; c < a; c++) {
    var d = F[b + 4 * c >> 2], e = Dd[d];
    e && (W.deleteRenderbuffer(e), e.name = 0, Dd[d] = null);
  }
}, glDeleteShader:a => {
  if (a) {
    var b = Fd[a];
    b ? (W.deleteShader(b), Fd[a] = null) : X ||= 1281;
  }
}, glDeleteTextures:(a, b) => {
  for (var c = 0; c < a; c++) {
    var d = F[b + 4 * c >> 2], e = Ed[d];
    e && (W.deleteTexture(e), e.name = 0, Ed[d] = null);
  }
}, glDeleteVertexArrays:(a, b) => {
  for (var c = 0; c < a; c++) {
    var d = F[b + 4 * c >> 2];
    W.deleteVertexArray(Gd[d]);
    Gd[d] = null;
  }
}, glDepthFunc:a => W.depthFunc(a), glDepthMask:a => {
  W.depthMask(!!a);
}, glDepthRangef:(a, b) => W.depthRange(a, b), glDisable:a => W.disable(a), glDrawArrays:(a, b, c) => {
  W.drawArrays(a, b, c);
}, glDrawArraysInstanced:(a, b, c, d) => {
  W.drawArraysInstanced(a, b, c, d);
}, glDrawBuffers:(a, b) => {
  for (var c = Qd[a], d = 0; d < a; d++) {
    c[d] = F[b + 4 * d >> 2];
  }
  W.drawBuffers(c);
}, glDrawElementsInstanced:(a, b, c, d, e) => {
  W.drawElementsInstanced(a, b, c, d, e);
}, glEnable:a => W.enable(a), glEnableVertexAttribArray:a => {
  W.enableVertexAttribArray(a);
}, glFlush:() => W.flush(), glFramebufferRenderbuffer:(a, b, c, d) => {
  W.framebufferRenderbuffer(a, b, c, Dd[d]);
}, glFramebufferTexture2D:(a, b, c, d, e) => {
  W.framebufferTexture2D(a, b, c, Ed[d], e);
}, glFrontFace:a => W.frontFace(a), glGenBuffers:(a, b) => {
  Ld(a, b, "createBuffer", Bd);
}, glGenFramebuffers:(a, b) => {
  Ld(a, b, "createFramebuffer", Cd);
}, glGenRenderbuffers:(a, b) => {
  Ld(a, b, "createRenderbuffer", Dd);
}, glGenTextures:(a, b) => {
  Ld(a, b, "createTexture", Ed);
}, glGenVertexArrays:(a, b) => {
  Ld(a, b, "createVertexArray", Gd);
}, glGenerateMipmap:a => W.generateMipmap(a), glGetIntegerv:(a, b) => Sd(a, b), glGetProgramiv:(a, b, c) => {
  if (c) {
    if (a >= Ad) {
      X ||= 1281;
    } else {
      if (a = V[a], 35716 == b) {
        a = W.getProgramInfoLog(a), null === a && (a = "(unknown error)"), F[c >> 2] = a.length + 1;
      } else if (35719 == b) {
        if (!a.wa) {
          for (b = 0; b < W.getProgramParameter(a, 35718); ++b) {
            a.wa = Math.max(a.wa, W.getActiveUniform(a, b).name.length + 1);
          }
        }
        F[c >> 2] = a.wa;
      } else if (35722 == b) {
        if (!a.ua) {
          for (b = 0; b < W.getProgramParameter(a, 35721); ++b) {
            a.ua = Math.max(a.ua, W.getActiveAttrib(a, b).name.length + 1);
          }
        }
        F[c >> 2] = a.ua;
      } else if (35381 == b) {
        if (!a.va) {
          for (b = 0; b < W.getProgramParameter(a, 35382); ++b) {
            a.va = Math.max(a.va, W.getActiveUniformBlockName(a, b).length + 1);
          }
        }
        F[c >> 2] = a.va;
      } else {
        F[c >> 2] = W.getProgramParameter(a, b);
      }
    }
  } else {
    X ||= 1281;
  }
}, glGetString:a => {
  var b = Hd[a];
  if (!b) {
    switch(a) {
      case 7939:
        b = Ud(Rd().join(" "));
        break;
      case 7936:
      case 7937:
      case 37445:
      case 37446:
        (b = W.getParameter(a)) || (X ||= 1280);
        b = b ? Ud(b) : 0;
        break;
      case 7938:
        b = Ud(`OpenGL ES 3.0 (${W.getParameter(7938)})`);
        break;
      case 35724:
        b = W.getParameter(35724);
        var c = b.match(/^WebGL GLSL ES ([0-9]\.[0-9][0-9]?)(?:$| .*)/);
        null !== c && (3 == c[1].length && (c[1] += "0"), b = `OpenGL ES GLSL ES ${c[1]} (${b})`);
        b = Ud(b);
        break;
      default:
        X ||= 1280;
    }
    Hd[a] = b;
  }
  return b;
}, glGetUniformBlockIndex:(a, b) => W.getUniformBlockIndex(V[a], b ? L(D, b) : ""), glGetUniformLocation:(a, b) => {
  b = b ? L(D, b) : "";
  if (a = V[a]) {
    var c = a, d = c.ja, e = c.ob, f;
    if (!d) {
      for (c.ja = d = {}, c.nb = {}, f = 0; f < W.getProgramParameter(c, 35718); ++f) {
        var g = W.getActiveUniform(c, f);
        var h = g.name;
        g = g.size;
        var m = Vd(h);
        m = 0 < m ? h.slice(0, m) : h;
        var l = c.Qa;
        c.Qa += g;
        e[m] = [g, l];
        for (h = 0; h < g; ++h) {
          d[l] = h, c.nb[l++] = m;
        }
      }
    }
    c = a.ja;
    d = 0;
    e = b;
    f = Vd(b);
    0 < f && (d = parseInt(b.slice(f + 1)) >>> 0, e = b.slice(0, f));
    if ((e = a.ob[e]) && d < e[0] && (d += e[1], c[d] = c[d] || W.getUniformLocation(a, b))) {
      return d;
    }
  } else {
    X ||= 1281;
  }
  return -1;
}, glInvalidateFramebuffer:(a, b, c) => {
  for (var d = Qd[b], e = 0; e < b; e++) {
    d[e] = F[c + 4 * e >> 2];
  }
  W.invalidateFramebuffer(a, d);
}, glLinkProgram:a => {
  a = V[a];
  W.linkProgram(a);
  a.ja = 0;
  a.ob = {};
}, glPixelStorei:(a, b) => {
  3317 == a ? Id = b : 3314 == a && (Jd = b);
  W.pixelStorei(a, b);
}, glReadPixels:(a, b, c, d, e, f, g) => {
  if (W.Ja) {
    W.readPixels(a, b, c, d, e, f, g);
  } else {
    var h = Wd(f);
    g >>>= 31 - Math.clz32(h.BYTES_PER_ELEMENT);
    W.readPixels(a, b, c, d, e, f, h, g);
  }
}, glRenderbufferStorageMultisample:(a, b, c, d, e) => W.renderbufferStorageMultisample(a, b, c, d, e), glScissor:(a, b, c, d) => W.scissor(a, b, c, d), glShaderSource:(a, b, c, d) => {
  for (var e = "", f = 0; f < b; ++f) {
    var g = (g = K[c + 4 * f >> 2]) ? L(D, g, d ? K[d + 4 * f >> 2] : void 0) : "";
    e += g;
  }
  W.shaderSource(Fd[a], e);
}, glStencilFunc:(a, b, c) => W.stencilFunc(a, b, c), glStencilFuncSeparate:(a, b, c, d) => W.stencilFuncSeparate(a, b, c, d), glStencilMask:a => W.stencilMask(a), glStencilOp:(a, b, c) => W.stencilOp(a, b, c), glStencilOpSeparate:(a, b, c, d) => W.stencilOpSeparate(a, b, c, d), glTexParameteri:(a, b, c) => W.texParameteri(a, b, c), glTexStorage2D:(a, b, c, d, e) => W.texStorage2D(a, b, c, d, e), glTexStorage3D:(a, b, c, d, e, f) => W.texStorage3D(a, b, c, d, e, f), glTexSubImage2D:(a, b, c, d, e, 
f, g, h, m) => {
  if (W.oa) {
    W.texSubImage2D(a, b, c, d, e, f, g, h, m);
  } else {
    if (m) {
      var l = Wd(h);
      W.texSubImage2D(a, b, c, d, e, f, g, h, l, m >>> 31 - Math.clz32(l.BYTES_PER_ELEMENT));
    } else {
      if (m) {
        l = Wd(h);
        var r = f * ((Jd || e) * ({5:3, 6:4, 8:2, 29502:3, 29504:4, 26917:2, 26918:2, 29846:3, 29847:4}[g - 6402] || 1) * l.BYTES_PER_ELEMENT + Id - 1 & -Id);
        m = l.subarray(m >>> 31 - Math.clz32(l.BYTES_PER_ELEMENT), m + r >>> 31 - Math.clz32(l.BYTES_PER_ELEMENT));
      } else {
        m = null;
      }
      W.texSubImage2D(a, b, c, d, e, f, g, h, m);
    }
  }
}, glUniform1i:(a, b) => {
  var c = W, d = c.uniform1i;
  var e = W.zb;
  if (e) {
    var f = e.ja[a];
    "number" == typeof f && (e.ja[a] = f = W.getUniformLocation(e, e.nb[a] + (0 < f ? `[${f}]` : "")));
    a = f;
  } else {
    X ||= 1282, a = void 0;
  }
  d.call(c, a, b);
}, glUniformBlockBinding:(a, b, c) => {
  a = V[a];
  W.uniformBlockBinding(a, b, c);
}, glUseProgram:a => {
  a = V[a];
  W.useProgram(a);
  W.zb = a;
}, glVertexAttribDivisor:(a, b) => {
  W.vertexAttribDivisor(a, b);
}, glVertexAttribIPointer:(a, b, c, d, e) => {
  W.vertexAttribIPointer(a, b, c, d, e);
}, glVertexAttribPointer:(a, b, c, d, e, f) => {
  W.vertexAttribPointer(a, b, c, !!d, e, f);
}, glViewport:(a, b, c, d) => W.viewport(a, b, c, d), invoke_vii:ce, isWindowsBrowser:function() {
  return -1 < navigator.platform.indexOf("Win");
}, provokingVertexWEBGL:function(a, b) {
  (a = v[a].C.ib) && a.provokingVertexWEBGL(b);
}, strftime:Zd, strftime_l:(a, b, c, d) => Zd(a, b, c, d), upload_image:function(a, b) {
  var c = k.images;
  c && (b = c.get(b)) && (a = v[a].C, a.pixelStorei(a.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), a.texImage2D(a.TEXTURE_2D, 0, a.RGBA, a.RGBA, a.UNSIGNED_BYTE, b), a.pixelStorei(a.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1));
}, wasm_start_image_decode:function(a, b, c) {
  b = k.HEAP8.subarray(b, b + c);
  c = new Uint8Array(c);
  c.set(b);
  createImageBitmap(new Blob([c])).then(function(d) {
    var e = (new OffscreenCanvas(d.width, d.height)).getContext("2d");
    e.drawImage(d, 0, 0);
    e = e.getImageData(0, 0, d.width, d.height);
    var f = e.data.length, g = k.tb(f);
    k.dc.set(e.data, g);
    k.fc(a, d.width, d.height, g, f);
  }).catch(function(d) {
    d = d.message || "decode failed";
    var e = k.zc(d) + 1, f = k.tb(e);
    k.Hc(d, f, e);
    k.hc(a, f);
    k.ec(f);
  });
}}, Z = function() {
  function a(c) {
    Z = c.exports;
    ta = Z.memory;
    ya();
    Pc = Z.__indirect_function_table;
    Aa.unshift(Z.__wasm_call_ctors);
    Da--;
    k.monitorRunDependencies?.(Da);
    0 == Da && (null !== Ea && (clearInterval(Ea), Ea = null), Fa && (c = Fa, Fa = null, c()));
    return Z;
  }
  var b = {env:de, wasi_snapshot_preview1:de,};
  Da++;
  k.monitorRunDependencies?.(Da);
  if (k.instantiateWasm) {
    try {
      return k.instantiateWasm(b, a);
    } catch (c) {
      A(`Module.instantiateWasm callback failed with error: ${c}`), ba(c);
    }
  }
  Ia ||= Ha("webgl2_advanced.wasm") ? "webgl2_advanced.wasm" : k.locateFile ? k.locateFile("webgl2_advanced.wasm", x) : x + "webgl2_advanced.wasm";
  Ma(b, function(c) {
    a(c.instance);
  }).catch(ba);
  return {};
}(), kc = a => (kc = Z.free)(a), Td = a => (Td = Z.malloc)(a);
k._setWebImage = (a, b, c) => (k._setWebImage = Z.setWebImage)(a, b, c);
var jc = a => (jc = Z.__getTypeName)(a);
k._wasm_image_decode_complete = (a, b, c, d, e) => (k._wasm_image_decode_complete = Z.wasm_image_decode_complete)(a, b, c, d, e);
k._wasm_image_decode_error = (a, b) => (k._wasm_image_decode_error = Z.wasm_image_decode_error)(a, b);
var Pa = k._ma_device__on_notification_unlocked = a => (Pa = k._ma_device__on_notification_unlocked = Z.ma_device__on_notification_unlocked)(a);
k._ma_malloc_emscripten = (a, b) => (k._ma_malloc_emscripten = Z.ma_malloc_emscripten)(a, b);
k._ma_free_emscripten = (a, b) => (k._ma_free_emscripten = Z.ma_free_emscripten)(a, b);
var Qa = k._ma_device_process_pcm_frames_capture__webaudio = (a, b, c) => (Qa = k._ma_device_process_pcm_frames_capture__webaudio = Z.ma_device_process_pcm_frames_capture__webaudio)(a, b, c), Ra = k._ma_device_process_pcm_frames_playback__webaudio = (a, b, c) => (Ra = k._ma_device_process_pcm_frames_playback__webaudio = Z.ma_device_process_pcm_frames_playback__webaudio)(a, b, c), ee = (a, b) => (ee = Z.setThrew)(a, b), fe = a => (fe = Z._emscripten_stack_restore)(a), ge = () => (ge = Z.emscripten_stack_get_current)();
k.dynCall_iiiji = (a, b, c, d, e, f) => (k.dynCall_iiiji = Z.dynCall_iiiji)(a, b, c, d, e, f);
k.dynCall_iij = (a, b, c, d) => (k.dynCall_iij = Z.dynCall_iij)(a, b, c, d);
k.dynCall_iiji = (a, b, c, d, e) => (k.dynCall_iiji = Z.dynCall_iiji)(a, b, c, d, e);
k.dynCall_jii = (a, b, c) => (k.dynCall_jii = Z.dynCall_jii)(a, b, c);
k.dynCall_vijj = (a, b, c, d, e, f) => (k.dynCall_vijj = Z.dynCall_vijj)(a, b, c, d, e, f);
k.dynCall_jiji = (a, b, c, d, e) => (k.dynCall_jiji = Z.dynCall_jiji)(a, b, c, d, e);
k.dynCall_viijii = (a, b, c, d, e, f, g) => (k.dynCall_viijii = Z.dynCall_viijii)(a, b, c, d, e, f, g);
k.dynCall_iiiiij = (a, b, c, d, e, f, g) => (k.dynCall_iiiiij = Z.dynCall_iiiiij)(a, b, c, d, e, f, g);
k.dynCall_iiiiijj = (a, b, c, d, e, f, g, h, m) => (k.dynCall_iiiiijj = Z.dynCall_iiiiijj)(a, b, c, d, e, f, g, h, m);
k.dynCall_iiiiiijj = (a, b, c, d, e, f, g, h, m, l) => (k.dynCall_iiiiiijj = Z.dynCall_iiiiiijj)(a, b, c, d, e, f, g, h, m, l);
function ce(a, b, c) {
  var d = ge();
  try {
    Qc(a)(b, c);
  } catch (e) {
    fe(d);
    if (e !== e + 0) {
      throw e;
    }
    ee(1, 0);
  }
}
var he;
Fa = function ie() {
  he || je();
  he || (Fa = ie);
};
function je() {
  function a() {
    if (!he && (he = !0, k.calledRun = !0, !ua)) {
      k.noFSInit || Ub || (Ub = !0, k.stdin = k.stdin, k.stdout = k.stdout, k.stderr = k.stderr, k.stdin ? Vb("stdin", k.stdin) : Qb("/dev/tty", "/dev/stdin"), k.stdout ? Vb("stdout", null, k.stdout) : Qb("/dev/tty", "/dev/stdout"), k.stderr ? Vb("stderr", null, k.stderr) : Qb("/dev/tty1", "/dev/stderr"), Rb("/dev/stdin", 0), Rb("/dev/stdout", 1), Rb("/dev/stderr", 1));
      zb = !1;
      Ta(Aa);
      aa(k);
      if (k.onRuntimeInitialized) {
        k.onRuntimeInitialized();
      }
      if (k.postRun) {
        for ("function" == typeof k.postRun && (k.postRun = [k.postRun]); k.postRun.length;) {
          var b = k.postRun.shift();
          Ba.unshift(b);
        }
      }
      Ta(Ba);
    }
  }
  if (!(0 < Da)) {
    if (k.preRun) {
      for ("function" == typeof k.preRun && (k.preRun = [k.preRun]); k.preRun.length;) {
        Ca();
      }
    }
    Ta(za);
    0 < Da || (k.setStatus ? (k.setStatus("Running..."), setTimeout(function() {
      setTimeout(function() {
        k.setStatus("");
      }, 1);
      a();
    }, 1)) : a());
  }
}
if (k.preInit) {
  for ("function" == typeof k.preInit && (k.preInit = [k.preInit]); 0 < k.preInit.length;) {
    k.preInit.pop()();
  }
}
je();
moduleRtn = ca;



  return moduleRtn;
}
);
})();
export default Rive;
